import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../data/redux/store";
import { message } from "antd";

/** === IMPORT ALL MASTER ACTIONS HERE === */

// Department
import { createDepartment, deleteDepartment, fetchAllDepartments } from "../data/redux/department/departmentAction";
import { getUserById, updateUser } from "../data/redux/user/userAction";
import { createHoliday, deleteHoliday, fetchAllHolidays, updateHoliday } from "../../core/data/redux/holiday/holidayAction";
import { createDesignation, deleteDesignation, fetchAllDesignations } from "../data/redux/designation/designationAction";
import { createPolicy, deletePolicy, fetchAllPolicies, updatePolicy } from "../data/redux/policy/policyAction";
import { createSkill, deleteSkill, fetchALlSkill } from "../data/redux/skill/skill.Action";
import { createWeekoff, deleteWeekoff, fetchAllWeekoff } from "../data/redux/weekoff/weekoff.Action";
import { createBranch, deletebranchById, fetchAllBranch } from "../data/redux/branch/branch.Action";
import { createexperience, DeleteExperience, fetchingexperience } from "../data/redux/experience/experience.Action";
import { createTicket, fetchAllTickets, fetchTicketsByDepartment, fetchTicketsByEmployeeHierarchy, fetchTicketsSummaryByDepartment, fetchTicketSummary } from "../data/redux/tickets/ticket/ticketActions";
import { createTicketCategory, deleteTicketCategory, fetchTicketAllCategories, fetchTicketCategorySummary, fetchTicketCategorySummaryByDepartment } from "../data/redux/tickets/ticketCategoryActions";
import { createTask, deletetask, fetchAllTask } from "../data/redux/calendar/calendarAction";
import dayjs from "dayjs";
import { createLeaveRequest, deleteLeaveRequest, fetchAllLeaveRequestsWithCancelation } from "../data/redux/attendance/leave/leaveAction";
import { createShiftSchedule, deleteShiftSchedule, fetchAllShiftSchedules } from "../data/redux/attendance/shiftSchedule/shiftScheduleAction";
import { createFinancialYear, fetchFinancialYearsByCompanyId, updateFinancialYear } from "../data/redux/financialYear/financialYearActions";
import { createGoaltype, deleteGoaltype, fetchAllGoaltype } from "../data/redux/performance/goaltype/goaltypeAction";
import { createGoal, deleteGoal, fetchAllGoal } from "../data/redux/performance/goal/goalAction";
import { createEmployee, deleteEmployee, fetchEmployeeAnalytics, getEmployeeById, getEmployeeByUserId, getEmployees, updateEmployee } from "../data/redux/employee/employeeAction";
import { createTraining, deletetraininglistById, fetchAlltraininglist } from "../data/redux/training/trainingAction";
import { createTrainer, deletetrainerById, fetchAlltrainer } from "../data/redux/training/trainer/trainerAction";
import { createTrainingType, deletetrainingtypeById, fetchAlltrainingtype } from "../data/redux/training/trainertype/trainertypeAction";
import { createAssetCategory, deleteAssetCategory, fetchAllAssetCategories } from "../data/redux/asset/assetCategoryActions";
import { createAssetRequest, deleteAssetRequest, fetchAssetRequestsByEmployeeId } from "../data/redux/asset/assetRequest/assetRequestAction";
import { createPromotion, deletepromotion, fetchAllPromotion } from "../data/redux/promotion/promotionAction";
import { createTermination, deletetermination, fetchAllTermination } from "../data/redux/termination/terminationAction";
import { createResignation, deleteResignation, fetchAllResignations } from "../data/redux/resignation/resignationAction";
import { createClient, deleteClient, fetchAllClients, fetchClientSummary, fetchVendorSummary } from "../data/redux/projects/client/clientAction";
import { createTaskBoard, deleteTaskBoard, fetchTaskBoards } from "../data/redux/projects/taskBoard/taskBoardActions";
import { createTask as createTaskProject, deleteTask, fetchTasks } from "../data/redux/projects/task/taskActions";
import { createWorkLog, deleteWorkLog, fetchAllWorkLogs } from "../data/redux/attendance/timeworkSheet/timeworkSheetAction";
import { createPfEmployee, deletePfEmployee, fetchAllPfEmployees } from "../data/redux/payroll/Accounting/providentFund/pfEmployee/pfEmployeeActions";
import { createProvidentFund, deleteProvidentFund, fetchAllProvidentFunds } from "../data/redux/payroll/Accounting/providentFund/providentFundActions";
import { filterByStatus } from "../utils/filterActiveData";
import { createPfWithdrawal, deletePfWithdrawal, fetchAllPfWithdrawals } from "../data/redux/payroll/Accounting/providentFund/pfWithdrawal/pfWithdrawalActions";
import { createPfLoan, deletePfLoan, fetchAllPfLoans } from "../data/redux/payroll/Accounting/providentFund/pfLoanRequest/pfLoanActions";
import { createPfPolicy, deletePfPolicy, fetchAllPfPolicies } from "../data/redux/payroll/Accounting/providentFund/pfpolicies/pfPolicyActions";
import { createTax, deleteTax, fetchAllTaxes } from "../data/redux/payroll/TDS/taxes/taxActions";
import { createTdsTaxRegime, deleteTdsTaxRegime, fetchTdsTaxRegimes } from "../data/redux/payroll/TDS/tdsTaxRegime/tdsTaxRegimeActions";
import { createTdsSurchargeCess, deleteTdsSurchargeCess, fetchTdsSurchargeCessList } from "../data/redux/payroll/TDS/tdsSurchargeCess/tdsSurchargeCessActions";
import { createEsicDisablementType, deleteEsicDisablementType, fetchEsicDisablementTypeList } from "../data/redux/payroll/ESIC/Master/Disablement/disablementAction";
import { createEsicBranch, deleteEsicBranch, fetchEsicBranchList } from "../data/redux/payroll/ESIC/Master/Branch/branchAction";
import { createEsicReason, deleteEsicReason, fetchEsicReasonList } from "../data/redux/payroll/ESIC/Master/Reason/ReasonAction";
import { createEsicBenefitType, deleteEsicBenefitType, fetchEsicBenefitTypeList } from "../data/redux/payroll/ESIC/Master/Benefit/benefitAction";
import { createEsicEmployee, deleteEsicEmployee, fetchEsicEmployees } from "../data/redux/payroll/ESIC/employeeMapping/employeemappingAction";
import { createCategory, deleteCategory, fetchAllCategories } from "../data/redux/payroll/Accounting/expensesCategories/expensesCategoriesAction";
import { createExpense, deleteExpense, fetchExpensesByEmployeeId } from "../data/redux/payroll/Accounting/expenses/expenseActions";
import { createBudgetRevenue, deleteBudgetRevenue, fetchAllBudgetRevenues } from "../data/redux/payroll/Accounting/budgetRevenues/budgetRevenueActions";
import { createBudgetExpense, deleteBudgetExpense, fetchAllBudgetExpenses } from "../data/redux/payroll/Accounting/budgetExpenses/budgetExpensesActions";
import { createBudget, deleteBudget, fetchAllBudgets } from "../data/redux/payroll/Accounting/budgets/budgetsAction";
import { createWorkfromHome, DeleteWorkfromHome, getworkfromhomeByEmployeeId } from "../data/redux/attendance/workfromrequest/workfromhome.action";
import { createEarning, deleteEarning, fetchEarnings } from "../data/redux/payroll/payrollComponent/earning/earningActions";
import { createOvertimePay, deleteOvertimePay, fetchOvertimePays } from "../data/redux/payroll/payrollComponent/overtimePayRate/overtimePayActions";
import { deleteDeduction, fetchDeductions } from "../data/redux/payroll/payrollComponent/deduction/deductionActions";
import { createDeduction } from "../data/redux/deduction/deductionAction";
import { createPayscale, deletePayscale, fetchPayscales } from "../data/redux/payroll/payrollComponent/payscale/payscaleActions";
import { createMaintenance, deleteMaintenance, fetchAllMaintenances } from "../data/redux/asset/assetMaintenanceAction/assetMaintenanceAction";
import { createRole, deleteRole, fetchAllRoles } from "../data/redux/user/role/roleAction";
import { createEmail, deleteMail, fetchAllEmail } from "../data/redux/email_configuration/email.Action";


// Example future masters:
// import { createDesignation } from "../core/data/redux/designation/designationAction";
// import { createProject } from "../core/data/redux/project/projectAction";


export default function GlobalMasterListener() {
    const dispatch = useDispatch<AppDispatch>();
    const user = useSelector((state: any) => state.auth.user);
    const departments = useSelector((state: any) => state.department.departments);
    const holidays = useSelector((state: any) => state.holiday.holidays);
    const designations = useSelector((state: any) => state.designation.designations);
    const policies = useSelector((state: any) => state.policy.policies);
    const skills = useSelector((state: any) => state.skill.skill);
    const weekoff = useSelector((state: any) => state.weekoff.weekoff);
    const { experiences } = useSelector((state: any) => state.experience);
    const { employeesbyUser } = useSelector((state: any) => state.employee);
    const { TicketsCategories } = useSelector((state: any) => state.ticket.ticketCategory);
    const { employeeTasks } = useSelector((state: any) => state.calendar);
    const { leaveRequests } = useSelector((state: any) => state.attendance.leaveRequests);
    const { shiftSchedules } = useSelector((state: any) => state.attendance.shiftSchedule);
    const { shiftMasters } = useSelector((state: any) => state.attendance.shift);
    const { activeCompany } = useSelector((state: any) => state.companyDetails);
    const companyId = activeCompany?.company_detail_id
    const goaltype = useSelector((state: any) => state.performance.goaltype.goaltype);
    const { goal } = useSelector((state: any) => state.performance.goal);
    const { employees } = useSelector((state: any) => state.employee);
    const { Training: trainingList } = useSelector((state: any) => state.training.training);
    const { trainer } = useSelector((state: any) => state.training.trainer);
    const { trainingType } = useSelector((state: any) => state.training);
    const { assetCategories } = useSelector((state: any) => state.asset.assetCategory);
    const { AssetByEmployee = [] } = useSelector((state: any) => state.asset.assetRequest);
    const { promotion } = useSelector((state: any) => state.promotion);
    const { branch } = useSelector((state: any) => state.branch);
    const { termination } = useSelector((state: any) => state.termination);
    const { resignation } = useSelector((state: any) => state.resignation);
    const { clients } = useSelector((state: any) => state.project.clients);
    const { taskBoards } = useSelector((state: any) => state.project.taskBoard);
    const { tasks } = useSelector((state: any) => state.project.task);
    const { workLogs } = useSelector((state: any) => state.attendance.worklog);
    const { records } = useSelector((state: any) => state.providentFund.pfEmployeeMapping);
    const { records: pfemployeeMapping = [] } = useSelector((state: any) => state.providentFund.pfEmployeeMapping);
    const employeeMapping = filterByStatus(pfemployeeMapping, 'active', 'status');
    const { records: pfEmployees } = useSelector((state: any) => state.providentFund.pfEmployeeMapping);
    const { taxes } = useSelector((state: any) => state.accounting.taxes);
    const { regimes = [] } = useSelector((state: any) => state.TDS.tdsTaxRegime);
    const { surchargeCessList } = useSelector((state: any) => state.TDS.tdsSurchargeCess);
    const { list: disablementList = [] } = useSelector((state: any) => state.esic.disablement);
    const { branchList = [] } = useSelector((state: any) => state.esic.branch);
    const { list: reasonList = [] } = useSelector((state: any) => state.esic.reason);
    const { benefitTypeList = [] } = useSelector((state: any) => state.esic.benefit);
    const { records: esicEmployees = [] } = useSelector((state: RootState) => state.esic.esicEmployee);
    const { employees: allEmployees = [] } = useSelector((state: RootState) => state.employee);
    const { categories } = useSelector((state: any) => state.accounting.expensesCategories);
    const { expenseByEmployee } = useSelector((state: any) => state.accounting.expenses);
    const employeeId = employeesbyUser?.employeeId;
    const creatingRef = useRef(false);
    const { revenues } = useSelector((state: any) => state.accounting.budgetRevenue);
    const { expenses } = useSelector((state: any) => state.accounting.budgetExpenses);
    const { budgets } = useSelector((state: any) => state.accounting.budget);
    const { workfromhome } = useSelector((state: any) => state.workfromHome);
    const { earnings } = useSelector((state: any) => state.payroll.earning);
    const { overtimePays } = useSelector((state: any) => state.payroll.overtimRate);
    const { deductions } = useSelector((state: any) => state.payroll.deduction);
    const { roles } = useSelector((state: any) => state.role);
    const [tabledata, settabledata] = useState([]);


    useEffect(() => {
        if (!employeesbyUser?.employeeId) {
            dispatch(getEmployeeByUserId({ userId: user?.UserId }));
        }
    }, [dispatch]);

    /** 
     * Helper: Find department by name (case-insensitive)
     */
    const getDepartmentIdByName = (name: string) => {
        const match = departments.find(
            (d: any) => d.Name.toLowerCase() === name.toLowerCase()
        );
        return match?.Id || null;
    };

    const getHolidayIdByName = (name: string) => {
        if (!Array.isArray(holidays)) return null;

        const match = holidays.find(
            (h: any) => h.Name?.toLowerCase() === name.toLowerCase()
        );
        return match?.Id || null;
    };

    const getDesignationIdByName = (name: string) => {
        if (!Array.isArray(designations)) return null;

        const match = designations.find(
            (d: any) =>
                d.DesignationName?.toLowerCase() === name.toLowerCase()
        );

        return match?.DesignationId || null;
    };
    const getPolicyIdByName = (name: string) => {
        if (!Array.isArray(policies)) return null;

        const match = policies.find(
            (p: any) => p.Name?.toLowerCase() === name.toLowerCase()
        );

        return match?.Id || null;
    };
    const getSkillIdByName = (name: string) => {
        if (!Array.isArray(skills)) return null;

        const match = skills.find(
            (s: any) => s.Name?.toLowerCase() === name.toLowerCase()
        );

        return match?.Id || null;
    };
    const getWeekoffIdByName = (name: string) => {
        if (!Array.isArray(weekoff)) return null;

        const match = weekoff.find(
            (w: any) => w.Name?.toLowerCase() === name.toLowerCase()
        );

        return match?.weekOff_id || null;
    };
    const getExperienceIdByLabel = (label: string) => {
        if (!Array.isArray(experiences)) return null;

        const match = experiences.find(
            (e: any) => e.Label?.toLowerCase() === label.toLowerCase()
        );
        return match?.Id || null;
    };
    const getTicketCategoryIdByName = (name: string) => {
        if (!Array.isArray(TicketsCategories)) return null;

        const match = TicketsCategories.find(
            (c: any) =>
                c.category_name?.toLowerCase() === name.toLowerCase()
        );

        return match?.ticket_category_id || null;
    };
    const getTaskIdByName = (name: string) => {
        if (!Array.isArray(employeeTasks)) return null;

        const match = employeeTasks.find(
            (t: any) => t.Name?.toLowerCase() === name.toLowerCase()
        );
        return match?.id || null;
    };
    const getLeaveRequestIdByEmployeeAndDate = (
        employeeId: number,
        fromDate: string
    ) => {
        if (!Array.isArray(leaveRequests)) return null;

        const match = leaveRequests.find(
            (l: any) =>
                Number(l.EmployeeId) === Number(employeeId) &&
                dayjs(l.FromDate).isSame(dayjs(fromDate), "day")
        );

        return match?.Id || null;
    };
    const getScheduleIdByEmployeeAndDate = (
        employeeId: number,
        date: string
    ) => {
        if (!Array.isArray(shiftSchedules)) return null;

        const match = shiftSchedules.find((s: any) =>
            s.EmployeeIDs?.includes(employeeId) &&
            dayjs(date).isBetween(
                dayjs(s.FromDate),
                dayjs(s.ToDate),
                "day",
                "[]"
            )
        );

        return match?.ScheduleID || null;
    };
    const getTrainingIdByName = (name: string) => {
        if (!Array.isArray(trainingList)) return null;

        const match = trainingList.find(
            (t: any) => t.Name?.toLowerCase() === name.toLowerCase()
        );

        return match?.Id || null;
    };
    const getTrainerIdByName = (name: string) => {
        if (!Array.isArray(trainer)) return null;

        const match = trainer.find(
            (t: any) => t.Name?.toLowerCase() === name.toLowerCase()
        );

        return match?.Id || null;
    };
    const normalizeRequestNumber = (val?: string) => {
        if (!val) return "";

        return val
            .toString()
            .toLowerCase()
            .replace(/[\s-]/g, "")   // remove spaces & hyphens
            .replace(/^ar/, "")      // remove leading AR
            .replace(/^0+/, "");     // remove leading zeros
    };


    const getAssetRequestIdByRequestNumber = (requestNumber: string) => {
        if (!Array.isArray(AssetByEmployee)) return null;

        const input = normalizeRequestNumber(requestNumber);

        const match = AssetByEmployee.find((r: any) => {
            const stored = normalizeRequestNumber(r.RequestNumber);
            return stored === input;
        });

        return match?.Id || null;
    };
    const getPromotionIdByEmployeeName = (name: string) => {
        if (!Array.isArray(promotion)) return null;

        const match = promotion.find((p: any) =>
            p.Name?.toLowerCase().includes(name.toLowerCase())
        );

        return match?.Id || null;
    };
    const getTerminationIdByEmployeeName = (name: string) => {
        if (!Array.isArray(termination)) return null;

        const match = termination.find((t: any) =>
            t.Resigning_Employee?.toLowerCase().includes(name.toLowerCase())
        );

        return match?.ID || match?.Id || null;
    };

    const getResignationIdByEmployeeName = (name: string) => {
        if (!Array.isArray(resignation)) return null;

        const match = resignation.find((r: any) =>
            r.Resigning_Employee?.toLowerCase().includes(name.toLowerCase())
        );

        return match?.Id || null;
    };
    const getTaxRegimeIdByName = (name: string) => {
        const match = regimes.find(
            (r: any) => r.RegimeName?.toLowerCase() === name.toLowerCase()
        );
        return match?.TaxRegimeID || null;
    };
    const getDisablementIdByName = (name: string) => {
        if (!Array.isArray(disablementList)) return null;

        const match = disablementList.find(
            (d: any) =>
                d.disablement_type?.toLowerCase() === name.toLowerCase()
        );

        return match?.disablement_id || null;
    };
    const getBranchIdByName = (name: string) => {
        if (!Array.isArray(branchList)) return null;

        const match = branchList.find(
            (b: any) =>
                b.branch_name?.toLowerCase() === name.toLowerCase()
        );

        return match?.branch_id || null;
    };
    const getEsicReasonIdByText = (text: string) => {
        if (!Array.isArray(reasonList)) return null;

        const match = reasonList.find(
            (r: any) =>
                r.reason_text?.toLowerCase() === text.toLowerCase()
        );

        return match?.reason_id || null;
    };
    const getEsicBenefitIdByName = (name: string) => {
        if (!Array.isArray(benefitTypeList)) return null;

        const match = benefitTypeList.find(
            (b: any) =>
                b.benefit_name?.toLowerCase() === name.toLowerCase()
        );

        return match?.benefit_id || null;
    };
    const getCategoryIdByName = (name: string) => {
        return categories.find((cat: any) => cat.category?.toLowerCase() === name.toLowerCase())?.expenses_categories_id;
    };





    // ---------------------------------------------------
    //                AI Create Department
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name, status } = event.detail;

            const data = {
                Name: name,
                Description: "",
                Status: status || "active",
                hrId: [],
                CreatedBy: user?.UserId,
                ModifiedBy: user?.UserId,
            };

            const result: any = await dispatch(createDepartment(data));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Department "${name}" created successfully`);
                dispatch(fetchAllDepartments());
            } else {
                message.error(result.payload?.error || "Failed to create department");
            }
        };

        window.addEventListener("ai-create-department", handler);
        return () => window.removeEventListener("ai-create-department", handler);
    }, [dispatch, user, departments]);


    // ---------------------------------------------------
    //                AI Delete Department
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            const departmentId = getDepartmentIdByName(name);

            if (!departmentId) {
                message.error(`Department "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deleteDepartment({ departmentId }));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Department "${name}" deleted`);
                dispatch(fetchAllDepartments());
            } else {
                message.error(result.payload?.error || "Delete failed");
            }
        };

        window.addEventListener("ai-delete-department", handler);
        return () => window.removeEventListener("ai-delete-department", handler);
    }, [dispatch, departments]);


    // ---------------------------------------------------
    //            AI Create Holiday
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name, startDate, endDate, description, status, holidayType } = event.detail;

            const data = {
                Name: name,
                StartDate: startDate,
                EndDate: endDate,
                Description: description,
                Status: status || "active",
                CreatedBy: user?.UserId,
                ModifiedBy: user?.UserId,
                HolidayType: holidayType
            };

            const result: any = await dispatch(createHoliday(data));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Holiday "${name}" created successfully`);
                dispatch(fetchAllHolidays());
            } else {
                message.error(result.payload?.error || "Failed to create holiday");
            }
        };

        window.addEventListener("ai-create-holiday", handler);
        return () => window.removeEventListener("ai-create-holiday", handler);
    }, [dispatch, user]);

    // ---------------------------------------------------
    //                AI Delete Holiday
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            const holidayId = getHolidayIdByName(name);

            if (!holidayId) {
                message.error(`Holiday "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deleteHoliday({ holidayId }));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Holiday "${name}" deleted`);
                dispatch(fetchAllHolidays());
            } else {
                message.error(result.payload?.error || "Failed to delete holiday");
            }
        };

        window.addEventListener("ai-delete-holiday", handler);
        return () => window.removeEventListener("ai-delete-holiday", handler);
    }, [dispatch, holidays]);

    // ---------------------------------------------------
    //                AI Create Designation
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name, description, status } = event.detail;

            if (!name) {
                message.error("Designation name is required");
                return;
            }

            const data = {
                Name: name,
                DepartmentId: null,
                Description: description || "",
                Status: status || "active",
                CreatedBy: user?.UserId,
                ModifiedBy: user?.UserId,
            };

            const result: any = await dispatch(createDesignation(data));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Designation "${name}" created successfully`);
                dispatch(fetchAllDesignations());
            } else {
                message.error(result.payload?.error || "Failed to create designation");
            }
        };

        window.addEventListener("ai-create-designation", handler);
        return () => window.removeEventListener("ai-create-designation", handler);
    }, [dispatch, user]);

    // ---------------------------------------------------
    //                AI Delete Designation
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Designation name is required");
                return;
            }

            const designationId = getDesignationIdByName(name);

            if (!designationId) {
                message.error(`Designation "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deleteDesignation(designationId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Designation "${name}" deleted`);
                dispatch(fetchAllDesignations());
            } else {
                message.error(result.payload?.error || "Failed to delete designation");
            }
        };

        window.addEventListener("ai-delete-designation", handler);
        return () => window.removeEventListener("ai-delete-designation", handler);
    }, [dispatch, designations]);

    // ---------------------------------------------------
    //                AI Create Policy
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                name,
                description,
                selectedType,
                selectedTypeId,
                effectiveDate,
                status,
                file,
                isPublic,
                privateAccess
            } = event.detail;

            if (!name) {
                message.error("Policy name is required");
                return;
            }

            if (!file) {
                message.error("Policy document (PDF) is required");
                return;
            }

            // USE FORMDATA
            const formData = new FormData();

            formData.append("Name", name);
            formData.append("Description", description || "");
            formData.append("SelectedType", selectedType || "Department");
            formData.append("EffectiveDate", effectiveDate || new Date().toISOString().split("T")[0]);
            formData.append("Status", status || "active");
            formData.append("IsPublic", String(isPublic ?? true));
            formData.append("CreatedBy", user?.UserId);

            // arrays must be stringified
            formData.append("SelectedTypeId", JSON.stringify(selectedTypeId || []));
            formData.append("PrivateAccess", JSON.stringify(privateAccess || []));

            // 🔥 FILE
            formData.append("file", file);

            const result: any = await dispatch(createPolicy(formData));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Policy "${name}" created successfully`);
                dispatch(fetchAllPolicies());
            } else {
                message.error(result.payload?.error || "Failed to create policy");
            }
        };

        window.addEventListener("ai-create-policy", handler);
        return () => window.removeEventListener("ai-create-policy", handler);
    }, [dispatch, user]);

    // ---------------------------------------------------
    //                AI Delete Policy
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) { message.error("Policy name is required"); return; }
            const policyId = getPolicyIdByName(name);
            if (!policyId) { message.error(`Policy "${name}" not found`); return; }

            const result: any = await dispatch(deletePolicy({ policyId }));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Policy "${name}" deleted`);
                dispatch(fetchAllPolicies());
            } else {
                message.error(result.payload?.error || "Failed to delete policy");
            }
        };

        window.addEventListener("ai-delete-policy", handler);
        return () => window.removeEventListener("ai-delete-policy", handler);
    }, [dispatch, policies]);

    // ---------------------------------------------------
    //                AI Create Skill
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name, description, status } = event.detail;

            if (!name) {
                message.error("Skill name is required");
                return;
            }

            const data = {
                Name: name,
                Description: description || "",
                status: status || "active",
                createdBy: user?.UserId,
            };

            const result: any = await dispatch(createSkill(data));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Skill "${name}" created successfully`);
                dispatch(fetchALlSkill());
            } else {
                message.error(result.payload?.message || "Failed to create skill");
            }
        };

        window.addEventListener("ai-create-skill", handler);
        return () => window.removeEventListener("ai-create-skill", handler);
    }, [dispatch, user]);

    // ---------------------------------------------------
    //                AI Delete Skill
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Skill name is required");
                return;
            }

            const skillId = getSkillIdByName(name);

            if (!skillId) {
                message.error(`Skill "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deleteSkill(skillId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Skill "${name}" deleted`);
                dispatch(fetchALlSkill());
            } else {
                message.error(result.payload?.message || "Failed to delete skill");
            }
        };

        window.addEventListener("ai-delete-skill", handler);
        return () => window.removeEventListener("ai-delete-skill", handler);
    }, [dispatch, skills]);
    // ---------------------------------------------------
    //                AI Create Weekly Off
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                name,
                type,
                selectedTypeId,
                noOfDays,
                weekDays,
                weekPattern,
                description,
                status
            } = event.detail;

            if (!name) { message.error("Weekly Off name is required"); return; }

            const buildWeekPattern = (days: string[]) => {
                const allDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

                const pattern: any = {};
                allDays.forEach(d => {
                    pattern[d] = {
                        all: days.map(x => x.toLowerCase()).includes(d.toLowerCase()),
                        weeks: { 1: true, 2: true, 3: true, 4: true, 5: true }
                    };
                });

                return pattern;
            };

            const payload = {
                name,
                type,
                branch: type === "branch" ? selectedTypeId?.[0] || "" : "",
                department: type === "department" ? selectedTypeId?.[0] || "" : "",
                employee: type === "employee" ? selectedTypeId || [] : [],
                selectedTypeId: selectedTypeId || [],
                noOfDays,
                weekDays,
                weekPattern: typeof weekPattern === "string"
                    ? buildWeekPattern(weekDays)
                    : weekPattern,
                description: description || "",
                status: status || "active",
                createdBy: user?.UserId
            };

            const result: any = await dispatch(createWeekoff(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Weekly Off "${name}" created successfully`);
                dispatch(fetchAllWeekoff());
                dispatch(fetchAllBranch());
            } else {
                message.error(result.payload?.error || "Failed to create Weekly Off");
            }
        };

        window.addEventListener("ai-create-weeklyoff", handler);
        return () => window.removeEventListener("ai-create-weeklyoff", handler);
    }, [dispatch, user]);

    // ---------------------------------------------------
    //                AI Delete Weekly Off
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Weekly Off name is required");
                return;
            }

            const weekOffId = getWeekoffIdByName(name);

            if (!weekOffId) {
                message.error(`Weekly Off "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deleteWeekoff(weekOffId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Weekly Off "${name}" deleted`);
                dispatch(fetchAllWeekoff());
            } else {
                message.error(result.payload?.error || "Failed to delete Weekly Off");
            }
        };

        window.addEventListener("ai-delete-weeklyoff", handler);
        return () =>
            window.removeEventListener("ai-delete-weeklyoff", handler);
    }, [dispatch, weekoff]);
    // ---------------------------------------------------
    //                AI Create Experience
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { label, timePeriod, status } = event.detail;

            if (!label || !timePeriod) {
                message.error("Experience label and time period are required");
                return;
            }

            const payload = {
                label,
                timePeriod,
                status: status || "active",
                createdBy: user?.UserId
            };

            const result: any = await dispatch(createexperience(payload))
            if (result?.meta?.requestStatus === "fulfilled") {
                message.success(`Experience "${label}" created successfully`);
                dispatch(fetchingexperience());
            } else {
                message.error(result.payload?.error || "Failed to create experience");
            }
        };

        window.addEventListener("ai-create-experience", handler);
        return () => window.removeEventListener("ai-create-experience", handler);
    }, [dispatch, user, experiences]);
    // ---------------------------------------------------
    //                AI Delete Experience
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { label } = event.detail;

            const experienceId = getExperienceIdByLabel(label);

            if (!experienceId) {
                message.error(`Experience "${label}" not found`);
                return;
            }

            const result: any = await dispatch(DeleteExperience(experienceId))
            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Experience "${label}" deleted`);
                dispatch(fetchingexperience());
            } else {
                message.error(result.payload?.error || "Failed to delete experience");
            }
        };

        window.addEventListener("ai-delete-experience", handler);
        return () => window.removeEventListener("ai-delete-experience", handler);
    }, [dispatch, experiences]);

    // ---------------------------------------------------
    //            AI Create Ticket Category
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name, status } = event.detail;

            if (!name) { message.error("Ticket category name is required"); return; }
            if (!status) { message.error("Status is required"); return; }
            const payload = {
                category_name: name,
                status,
                created_by: user?.UserId,
            };

            const result: any = await dispatch(createTicketCategory(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Ticket category "${name}" created successfully`);
                dispatch(fetchTicketAllCategories());
            } else {
                message.error(result.payload?.error || "Failed to create ticket category");
            }
        };

        window.addEventListener("ai-create-ticket-category", handler);
        return () =>
            window.removeEventListener("ai-create-ticket-category", handler);
    }, [dispatch, user, TicketsCategories]);

    // ---------------------------------------------------
    //            AI Delete Ticket Category
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) { message.error("Ticket category name is required"); return; }
            const categoryId = getTicketCategoryIdByName(name);
            if (!categoryId) { message.error(`Ticket category "${name}" not found`); return; }
            const result: any = await dispatch(deleteTicketCategory(categoryId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Ticket category "${name}" deleted`);
                dispatch(fetchTicketAllCategories());
            } else {
                message.error(result.payload?.error || "Failed to delete ticket category");
            }
        };

        window.addEventListener("ai-delete-ticket-category", handler);
        return () =>
            window.removeEventListener("ai-delete-ticket-category", handler);
    }, [dispatch, TicketsCategories]);
    // ---------------------------------------------------
    //                AI Create Task
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name, description, fromDate, toDate, repeat, snoozeTime, meetingSchedule, attendees, mode, trainertype, allDay } = event.detail;

            if (!name) { message.error("Task name is required"); return; }
            if (!fromDate || !toDate) { message.error("Start and end date are required"); return; }
            if (!employeesbyUser?.employeeId) { message.error("Employee not found"); return; }

            const payload = {
                Name: name,
                Description: description || "",
                StartDate: fromDate,
                EndDate: toDate,
                Repeat: repeat || "Does Not Repeat",
                SnoozeTime: snoozeTime || "None",
                MeetingSchedule: meetingSchedule || "AI Created",
                attendees: attendees || [],
                Mode: mode || "offline",
                Trainertype: trainertype || "internal",
                AllDay: Boolean(allDay),
                CreatedBy: employeesbyUser.employeeId
            };

            const result: any = await dispatch(createTask(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Task "${name}" created successfully`);
                dispatch(fetchAllTask());
            } else {
                message.error(result.payload?.error || "Failed to create task");
            }
        };

        window.addEventListener("ai-create-task", handler);
        return () => window.removeEventListener("ai-create-task", handler);
    }, [dispatch, employeesbyUser]);
    // ---------------------------------------------------
    //                AI Delete Task
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Task name is required");
                return;
            }

            const taskId = getTaskIdByName(name);

            if (!taskId) {
                message.error(`Task "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deletetask(taskId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Task "${name}" deleted successfully`);
                dispatch(fetchAllTask());
            } else {
                message.error(result.payload?.error || "Failed to delete task");
            }
        };

        window.addEventListener("ai-delete-task", handler);
        return () => window.removeEventListener("ai-delete-task", handler);
    }, [dispatch, employeeTasks]);
    // ---------------------------------------------------
    //                AI Create Admin_Leave
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                employeeId,
                leaveTypeId,
                fromDate,
                toDate,
                leaveMode,
                reason
            } = event.detail;

            //VALIDATIONS (same as form)
            if (!employeeId) {
                message.error("Employee is required");
                return;
            }
            if (!leaveTypeId) {
                message.error("Leave type is required");
                return;
            }
            if (!fromDate || !toDate) {
                message.error("From and To dates are required");
                return;
            }
            if (!leaveMode) {
                message.error("Leave mode is required");
                return;
            }
            if (!reason) {
                message.error("Reason is required");
                return;
            }

            const from = dayjs(fromDate);
            const to = dayjs(toDate);

            if (to.isBefore(from)) {
                message.error("To date cannot be earlier than From date");
                return;
            }

            // 🔢 Calculate duration
            let duration = to.diff(from, "day") + 1;
            if (leaveMode === "Half Day") {
                duration = duration * 0.5;
            }

            const payload = {
                LeaveTypeId: Number(leaveTypeId),
                FromDate: from.toISOString(),
                ToDate: to.toISOString(),
                LeaveMode: leaveMode,
                Duration: duration,
                EmployeeId: Number(employeeId),
                LeaveRequestStatus: "Pending",
                Reason: reason,
                Description: reason,
                CreatedBy: user?.UserId,
                ModifiedBy: user?.UserId
            };

            const result: any = await dispatch(createLeaveRequest(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success("Leave request created successfully");
                dispatch(fetchAllLeaveRequestsWithCancelation());
            } else {
                message.error(result.payload?.error || "Failed to create leave request");
            }
        };

        window.addEventListener("ai-create-leave", handler);
        return () => window.removeEventListener("ai-create-leave", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    //                AI Delete Admin_Leave
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { employeeId, fromDate } = event.detail;

            if (!employeeId || !fromDate) {
                message.error("Employee and leave date are required");
                return;
            }

            const leaveId = getLeaveRequestIdByEmployeeAndDate(
                employeeId,
                fromDate
            );

            if (!leaveId) {
                message.error("Leave request not found");
                return;
            }

            const result: any = await dispatch(deleteLeaveRequest(leaveId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success("Leave request deleted successfully");
                dispatch(fetchAllLeaveRequestsWithCancelation());
            } else {
                message.error(result.payload?.error || "Failed to delete leave request");
            }
        };

        window.addEventListener("ai-delete-leave", handler);
        return () => window.removeEventListener("ai-delete-leave", handler);
    }, [dispatch, leaveRequests]);
    // ---------------------------------------------------
    //            AI Create Shift Schedule
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                employeeIds,
                departmentId,
                shiftName,
                shiftId,
                fromDate,
                toDate
            } = event.detail;

            if (!employeeIds?.length) {
                message.error("Employee is required");
                return;
            }
            if (!departmentId) {
                message.error("Department is required");
                return;
            }
            if (!shiftName) {
                message.error("Shift name is required");
                return;
            }
            if (!fromDate || !toDate) {
                message.error("Date range is required");
                return;
            }

            const shift = shiftMasters.find((s: any) => String(s.ShiftID) === String(shiftId));
            if (!shift) {
                message.error(`Shift "${shiftName}" not found`);
                return;
            }

            const payload = {
                EmployeeIDs: JSON.stringify(employeeIds),
                DepartmentID: departmentId,
                ShiftName: shift.ShiftName,
                ShiftID: String(shift.ShiftID),
                fromDate,
                toDate,
                MinStartTime: shift.StartTime,
                StartTime: shift.StartTime,
                MaxStartTime: shift.StartTime,
                MinEndTime: shift.EndTime,
                EndTime: shift.EndTime,
                MaxEndTime: shift.EndTime,
                BreakTime: shift.BreakTime || "00:30:00",
                AcceptExtraHours: false,
                IsPublished: false
            };

            const result: any = await dispatch(createShiftSchedule(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success("Shift schedule created successfully");
                dispatch(fetchAllShiftSchedules());
            } else {
                message.error(result.payload?.error || "Failed to create shift schedule");
            }
        };

        window.addEventListener("ai-create-shiftschedule", handler);
        return () =>
            window.removeEventListener("ai-create-shiftschedule", handler);
    }, [dispatch, shiftMasters]);
    // ---------------------------------------------------
    //            AI Delete Shift Schedule
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { employeeId, date } = event.detail;

            if (!employeeId || !date) {
                message.error("Employee and date are required");
                return;
            }

            const scheduleId = getScheduleIdByEmployeeAndDate(employeeId, date);

            if (!scheduleId) {
                message.error("Shift schedule not found");
                return;
            }

            const result: any = await dispatch(deleteShiftSchedule(scheduleId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success("Shift schedule deleted successfully");
                dispatch(fetchAllShiftSchedules());
            } else {
                message.error(result.payload?.error || "Failed to delete shift schedule");
            }
        };

        window.addEventListener("ai-delete-shiftschedule", handler);
        return () =>
            window.removeEventListener("ai-delete-shiftschedule", handler);
    }, [dispatch, shiftSchedules]);

    // ---------------------------------------------------
    //            AI Create Financial Year
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name, start_date, end_date, companyId } = event.detail;

            //VALIDATIONS (same as modal)
            if (!name) {
                message.error("Financial year name is required");
                return;
            }

            if (!/^fy_\d{4}$/i.test(name)) {
                message.error("Name must be in format fy_2025");
                return;
            }

            if (!start_date || !end_date) {
                message.error("Start date and end date are required");
                return;
            }

            const start = dayjs(start_date);
            const end = dayjs(end_date);

            if (start.isAfter(end)) {
                message.error("Start date cannot be after end date");
                return;
            }

            const payload = {
                name,
                start_date: start.format("YYYY-MM-DD"),
                end_date: end.format("YYYY-MM-DD"),
                CompanyID: companyId
            };

            const result: any = await dispatch(createFinancialYear(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Financial year "${name}" created successfully`);

                if (payload.CompanyID) {
                    dispatch(fetchFinancialYearsByCompanyId(payload.CompanyID));
                }
            } else {
                message.error(result.payload?.error || "Failed to create financial year");
            }
        };

        window.addEventListener("ai-create-financial-year", handler);
        return () =>
            window.removeEventListener("ai-create-financial-year", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    //            AI Update Financial Year
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { id, name, start_date, end_date, companyId } = event.detail;

            if (!id) {
                message.error("Financial year ID is required");
                return;
            }

            if (!name || !start_date || !end_date) {
                message.error("All fields are required");
                return;
            }

            const start = dayjs(start_date);
            const end = dayjs(end_date);

            if (start.isAfter(end)) {
                message.error("Start date cannot be after end date");
                return;
            }

            const payload = {
                id,
                name,
                start_date: start.format("YYYY-MM-DD"),
                end_date: end.format("YYYY-MM-DD"),
                CompanyID: companyId
            };

            const result: any = await dispatch(updateFinancialYear(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Financial year "${name}" updated successfully`);

                if (payload.CompanyID) {
                    dispatch(fetchFinancialYearsByCompanyId(payload.CompanyID));
                }
            } else {
                message.error(result.payload?.error || "Failed to update financial year");
            }
        };

        window.addEventListener("ai-update-financial-year", handler);
        return () =>
            window.removeEventListener("ai-update-financial-year", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    //            AI Create Goal Type
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { Goaltype, Description, Status } = event.detail;

            if (!Goaltype) {
                message.error("Goal type is required");
                return;
            }

            const payload = {
                Goaltype,
                Description: Description || "",
                Status: Status || "active",
                createdBy: user?.UserId
            };

            const result: any = await dispatch(createGoaltype(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Goal type "${Goaltype}" created successfully`);
                dispatch(fetchAllGoaltype());
            } else {
                message.error(result.payload?.message || "Failed to create goal type");
            }
        };

        window.addEventListener("ai-create-goaltype", handler);
        return () => window.removeEventListener("ai-create-goaltype", handler);
    }, [dispatch, user]);

    // ---------------------------------------------------
    //            AI Delete Goal Type
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            const match = goaltype?.find(
                (g: any) => g.Type?.toLowerCase() === name.toLowerCase()
            );

            if (!match) {
                message.error(`Goal type "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deleteGoaltype(match.Id));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Goal type "${name}" deleted`);
                dispatch(fetchAllGoaltype());
            } else {
                message.error(result.payload?.message || "Failed to delete goal type");
            }
        };

        window.addEventListener("ai-delete-goaltype", handler);
        return () => window.removeEventListener("ai-delete-goaltype", handler);
    }, [dispatch, goaltype]);
    // ---------------------------------------------------
    //                AI Create Goal
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { Name, Goaltype, Weightage, Description, Status } = event.detail;

            if (!Name) {
                message.error("Goal name is required");
                return;
            }

            if (!Goaltype) {
                message.error("Goal type is required");
                return;
            }

            if (Weightage === undefined || Weightage === null) {
                message.error("Weightage is required");
                return;
            }

            const payload = {
                Name,
                Goaltype,
                Weightage,
                Description: Description || "",
                Status: Status || "active",
                createdBy: user?.UserId
            };

            const result: any = await dispatch(createGoal(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Goal "${Name}" created successfully`);
                dispatch(fetchAllGoal());
            } else {
                message.error(result.payload?.message || "Failed to create goal");
            }
        };

        window.addEventListener("ai-create-goal", handler);
        return () => window.removeEventListener("ai-create-goal", handler);
    }, [dispatch, user]);

    // ---------------------------------------------------
    //                AI Delete Goal
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Goal name is required");
                return;
            }

            const match = goal?.find(
                (g: any) => g.name?.toLowerCase() === name.toLowerCase()
            );

            if (!match) {
                message.error(`Goal "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deleteGoal(match.id));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Goal "${name}" deleted successfully`);
                dispatch(fetchAllGoal());
            } else {
                message.error(result.payload?.error || "Failed to delete goal");
            }
        };

        window.addEventListener("ai-delete-goal", handler);
        return () => window.removeEventListener("ai-delete-goal", handler);
    }, [dispatch, goal]);
    // ---------------------------------------------------
    //                AI Create Employee (FULL MODE)
    // ---------------------------------------------------
    const isValidPhoneNumber = (number: string) => {
        if (!/^\d{10}$/.test(number)) return false;
        if (/^(\d)\1{9}$/.test(number)) return false;
        if (/^(\d{2})\1{4}$/.test(number)) return false;
        if (/^[01]/.test(number)) return false;
        if (["1234567890", "9876543210"].includes(number)) return false;
        return true;
    };

    useEffect(() => {
        const handler = async (event: any) => {
            const { firstName, lastName, email, password, confirmPassword, gender, username, dateOfBirth, phoneNumber, employeeRole } = event.detail;
            // VALIDATIONS (same as FULL MODE)
            if (!firstName || !/^[A-Za-z\s]+$/.test(firstName)) { message.error("Valid first name is required"); return; }
            if (!lastName || !/^[A-Za-z\s]+$/.test(lastName)) { message.error("Valid last name is required"); return; }
            if (!email || !/\S+@\S+\.\S+/.test(email)) { message.error("Valid email is required"); return; }
            if (!password || password.length < 6) { message.error("Password must be at least 6 characters"); return; }
            if (!confirmPassword || password !== confirmPassword) { message.error("Passwords do not match"); return; }
            if (!gender) { message.error("Gender is required"); return; }
            if (!username) { message.error("Username is required"); return; }
            if (!dateOfBirth) { message.error("Date of Birth is required"); return; }
            if (!phoneNumber || !isValidPhoneNumber(phoneNumber)) { message.error("Valid phone number is required"); return; }
            if (!employeeRole) { message.error("Role is required"); return; }

            // BUILD PAYLOAD (matches createEmployee)
            const payload = {
                Name: `${firstName} ${lastName}`,
                FirstName: firstName,
                LastName: lastName,
                Email: email,
                password,
                DateOfBirth: dayjs(dateOfBirth).format("YYYY-MM-DD"),
                GenderId: gender,
                mobile: phoneNumber,
                RoleId: employeeRole,
                CreatedBy: user?.UserId,
                ModifiedBy: user?.UserId,
                company_details_id: activeCompany?.company_detail_id,
                financial_year_id: activeCompany?.financial_year_id,
                maxUser: user?.total_user
            };

            try {
                const result: any = await dispatch(createEmployee(payload));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("Employee created successfully");
                    const newEmployeeId = result.payload?.data?.EmployeeId || result.payload?.data?.EmployeeID;

                    if (newEmployeeId) { await dispatch(getEmployeeById({ employeeId: newEmployeeId })); }
                    await dispatch(getEmployees());
                    dispatch(fetchEmployeeAnalytics());
                } else {
                    message.error(result.payload || "Failed to create employee");
                }
            } catch {
                message.error("Something went wrong");
            }
        };

        window.addEventListener("ai-create-employee", handler);
        return () => window.removeEventListener("ai-create-employee", handler);
    }, [dispatch, user, activeCompany]);
    // ---------------------------------------------------a
    //                AI Update Employee
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                employeeId,
                firstName,
                lastName,
                email,
                gender,
                username,
                dateOfBirth,
                phoneNumber,
                employeeRole,
                department,
                designation,
                employee_status,
                branch,
                job_location
            } = event.detail;

            if (!employeeId) {
                message.error("Employee ID is required");
                return;
            }

            //VALIDATIONS (only for provided fields)
            if (firstName && !/^[A-Za-z\s]+$/.test(firstName)) {
                message.error("Only letters allowed in first name");
                return;
            }

            if (lastName && !/^[A-Za-z\s]+$/.test(lastName)) {
                message.error("Only letters allowed in last name");
                return;
            }

            if (email && !/\S+@\S+\.\S+/.test(email)) {
                message.error("Invalid email format");
                return;
            }

            if (phoneNumber && !isValidPhoneNumber(phoneNumber)) {
                message.error("Invalid phone number");
                return;
            }

            if (dateOfBirth && !dayjs(dateOfBirth).isValid()) {
                message.error("Invalid Date of Birth");
                return;
            }

            // BUILD UPDATE PAYLOAD (partial update)
            const payload: any = {
                ModifiedBy: user?.UserId
            };

            if (firstName || lastName) {
                payload.FirstName = firstName;
                payload.LastName = lastName;
                payload.Name = `${firstName || ""} ${lastName || ""}`.trim();
            }

            if (email) payload.Email = email;
            if (gender) payload.GenderId = gender;
            if (username) payload.Username = username;
            if (dateOfBirth)
                payload.DateOfBirth = dayjs(dateOfBirth).format("YYYY-MM-DD");
            if (phoneNumber) payload.mobile = phoneNumber;
            if (employeeRole) payload.RoleId = employeeRole;

            // Job info
            if (department) payload.DepartmentId = department;
            if (designation) payload.DesignationId = designation;
            if (employee_status) payload.employee_status = employee_status;

            // Location info
            if (branch) payload.branch = branch;
            if (job_location) payload.job_location = job_location;

            try {
                const result: any = await dispatch(
                    updateEmployee({ employeeId, employeeData: payload })
                );

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("Employee updated successfully");

                    await dispatch(getEmployees());
                    await dispatch(getUserById(user?.UserId));
                    dispatch(fetchEmployeeAnalytics());
                } else {
                    message.error("Failed to update employee");
                }
            } catch {
                message.error("Something went wrong");
            }
        };

        window.addEventListener("ai-update-employee", handler);
        return () => window.removeEventListener("ai-update-employee", handler);
    }, [dispatch, user]);

    // ---------------------------------------------------
    //          AI Delete Employee (by Name)
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Employee name is required");
                return;
            }

            if (!Array.isArray(employees)) {
                message.error("Employee list not available");
                return;
            }

            // 🔍 Find employee by full name or partial name
            const match = employees.find((emp: any) => {
                const fullName = `${emp.FirstName || ""} ${emp.LastName || ""}`
                    .toLowerCase()
                    .trim();

                return (
                    fullName === name.toLowerCase().trim() ||
                    fullName.includes(name.toLowerCase().trim())
                );
            });

            if (!match) {
                message.error(`Employee "${name}" not found`);
                return;
            }

            try {
                const result: any = await dispatch(
                    deleteEmployee({ employeeId: match.EmployeeID })
                );

                if (result.meta.requestStatus === "fulfilled") {
                    message.success(`Employee "${name}" deleted successfully`);

                    await dispatch(getEmployees());
                    dispatch(fetchEmployeeAnalytics());
                } else {
                    message.error(result.payload?.error || "Failed to delete employee");
                }
            } catch {
                message.error("Something went wrong");
            }
        };

        window.addEventListener("ai-delete-employee", handler);
        return () => window.removeEventListener("ai-delete-employee", handler);
    }, [dispatch, employees]);
    // ---------------------------------------------------
    //            AI Create Training
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                Name,
                trainingType,
                trainer,
                Attendees,
                mode,
                location,
                trainingCost,
                StartDate,
                EndDate,
                Status,
                Description,
                days
            } = event.detail;

            //VALIDATIONS (same as modal)
            if (!Name) { message.error("Training name is required"); return; }
            if (!trainingType) { message.error("Training type is required"); return; }
            if (!trainer) { message.error("Trainer is required"); return; }
            if (!Attendees || !Attendees.length) { message.error("At least one attendee is required"); return; }
            if (!mode) { message.error("Training Mode is required"); return; }
            if (!trainingCost) { message.error("Training cost is required"); return; }
            if (!StartDate || !EndDate) { message.error("Start and End date are required"); return; }
            if (!Status) { message.error("Status is required"); return; }

            const payload = {
                Name,
                trainingType,
                trainer,
                Attendees: JSON.stringify(Attendees),
                Mode: mode,
                location,
                trainingCost,
                StartDate,
                EndDate,
                Status,
                Description: Description || "",
                RecurringDays: JSON.stringify(days || []),
                createdBy: user?.UserId,
                modifiedBy: user?.UserId
            };
            //payload dtaamatch and set correct like your backednd
            const result: any = await dispatch(createTraining(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Training "${Name}" created successfully`);
                dispatch(fetchAlltraininglist());
            } else {
                message.error(result.payload?.error || "Failed to create training");
            }
        };

        window.addEventListener("ai-create-training", handler);
        return () =>
            window.removeEventListener("ai-create-training", handler);
    }, [dispatch, user, trainingList]);
    // ---------------------------------------------------
    //            AI Delete Training
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Training name is required");
                return;
            }

            const trainingId = getTrainingIdByName(name);

            if (!trainingId) {
                message.error(`Training "${name}" not found`);
                return;
            }

            const result: any = await dispatch(
                deletetraininglistById({ id: trainingId })
            );

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Training "${name}" deleted successfully`);
                dispatch(fetchAlltraininglist());
            } else {
                message.error(result.payload?.error || "Failed to delete training");
            }
        };

        window.addEventListener("ai-delete-training", handler);
        return () =>
            window.removeEventListener("ai-delete-training", handler);
    }, [dispatch, trainingList]);
    // ---------------------------------------------------
    //                AI Create Trainer
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                name,
                phone,
                email,
                dob,
                address,
                description,
                status,
                trainerType,
                instituteName
            } = event.detail;

            if (!name) {
                message.error("Trainer name is required");
                return;
            }

            const payload: any = {
                Name: name,
                phone,
                email,
                dob,
                address,
                description: description || "",
                status: status || "active",
                trainerType: trainerType || "Employee",
                instituteName: instituteName || "",
                createdBy: user?.UserId
            };

            const result: any = await dispatch(createTrainer(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Trainer "${name}" created successfully`);
                dispatch(fetchAlltrainer());
            } else {
                message.error(result.payload?.message || "Failed to create trainer");
            }
        };

        window.addEventListener("ai-create-trainer", handler);
        return () => window.removeEventListener("ai-create-trainer", handler);
    }, [dispatch, user, trainer]);
    // ---------------------------------------------------
    //                AI Delete Trainer
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Trainer name is required");
                return;
            }

            const trainerId = getTrainerIdByName(name);

            if (!trainerId) {
                message.error(`Trainer "${name}" not found`);
                return;
            }

            const result: any = await dispatch(
                deletetrainerById({ id: trainerId })
            );

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Trainer "${name}" deleted successfully`);
                dispatch(fetchAlltrainer());
            } else {
                message.error(result.payload?.error || "Failed to delete trainer");
            }
        };

        window.addEventListener("ai-delete-trainer", handler);
        return () => window.removeEventListener("ai-delete-trainer", handler);
    }, [dispatch, trainer]);

    useEffect(() => {
        const handler = async (event: any) => {
            const { name, description, status } = event.detail;

            if (!name) {
                message.error("Training type name is required");
                return;
            }

            const payload: any = {
                name,
                description: description || "",
                status: status || "active",
                createdBy: user?.UserId
            };

            const result: any = await dispatch(createTrainingType(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Training type "${name}" created successfully`);
                dispatch(fetchAlltrainingtype());
            } else {
                message.error(result.payload?.message || "Failed to create training type");
            }
        };

        window.addEventListener("ai-create-training-type", handler);
        return () => window.removeEventListener("ai-create-training-type", handler);
    }, [dispatch, user]);

    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            const match = trainingType?.trainingtype?.find(
                (t: any) => t.Type?.toLowerCase() === name.toLowerCase()
            );

            if (!match) {
                message.error(`Training type "${name}" not found`);
                return;
            }

            const result: any = await dispatch(
                deletetrainingtypeById({ id: match.TrainingKey })
            );

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Training type "${name}" deleted successfully`);
                dispatch(fetchAlltrainingtype());
            } else {
                message.error(result.payload?.error || "Failed to delete training type");
            }
        };

        window.addEventListener("ai-delete-training-type", handler);
        return () => window.removeEventListener("ai-delete-training-type", handler);
    }, [dispatch, trainingType]);
    useEffect(() => {
        const handler = async (event: any) => {
            const { name, status } = event.detail;

            if (!name) {
                message.error("Asset category name is required");
                return;
            }

            const payload = {
                category_name: name,
                status: status || "active",
                created_by: user?.UserId
            };

            const result: any = await dispatch(createAssetCategory(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Asset category "${name}" created successfully`);
                dispatch(fetchAllAssetCategories());
            } else {
                message.error(result.payload?.error || "Failed to create asset category");
            }
        };

        window.addEventListener("ai-create-asset-category", handler);
        return () => window.removeEventListener("ai-create-asset-category", handler);
    }, [dispatch, user]);
    //asset category delete
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            const match = assetCategories?.find(
                (c: any) =>
                    c.category_name?.toLowerCase() === name.toLowerCase()
            );

            if (!match) {
                message.error(`Asset category "${name}" not found`);
                return;
            }

            const result: any = await dispatch(
                deleteAssetCategory(match.asset_category_id)
            );

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Asset category "${name}" deleted successfully`);
                dispatch(fetchAllAssetCategories());
            } else {
                message.error(result.payload?.error || "Failed to delete asset category");
            }
        };

        window.addEventListener("ai-delete-asset-category", handler);
        return () => window.removeEventListener("ai-delete-asset-category", handler);
    }, [dispatch, assetCategories]);
    // ---------------------------------------------------
    //        AI Create Asset Request
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                asset_category_id,
                name,
                quantity,
                requestDescription
            } = event.detail;

            const employeeId = employeesbyUser?.employeeId;

            if (!asset_category_id) {
                message.error("Asset category is required");
                return;
            }
            if (!Number.isInteger(Number(asset_category_id)) || Number(asset_category_id) <= 0) {
                message.error("Invalid asset category");
                return;
            }

            if (!name) {
                message.error("Asset name is required");
                return;
            }

            if (!quantity || quantity <= 0) {
                message.error("Quantity must be greater than 0");
                return;
            }

            if (!employeeId) {
                message.error("Employee not found");
                return;
            }

            const payload = {
                Name: name,
                AssetCategoryId: Number(asset_category_id),
                Quantity: quantity,
                RequestDescription: requestDescription || "",
                EmployeeId: employeeId,
                CreatedBy: user?.UserId,
                ModifiedBy: user?.UserId
            };

            const result: any = await dispatch(createAssetRequest(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Asset request for "${name}" created successfully`);
                dispatch(fetchAssetRequestsByEmployeeId(employeeId));
            } else {
                const apiError =
                    result?.payload?.error?.errors?.[0]?.msg ||
                    result?.payload?.message ||
                    "Failed to create asset request";

                message.error(apiError);
            }
        };

        window.addEventListener("ai-create-asset-request", handler);
        return () =>
            window.removeEventListener("ai-create-asset-request", handler);
    }, [dispatch, user, employeesbyUser]);

    // ---------------------------------------------------
    //        AI Delete Asset Request
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { requestNumber } = event.detail;
            const employeeId = employeesbyUser?.employeeId;

            if (!requestNumber) {
                message.error("Request number is required");
                return;
            }

            const requestId = getAssetRequestIdByRequestNumber(requestNumber);
            if (!requestId) {
                message.error(`Asset request "${requestNumber}" not found`);
                return;
            }

            const result: any = await dispatch(deleteAssetRequest(requestId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Asset request "${requestNumber}" deleted successfully`);
                dispatch(fetchAssetRequestsByEmployeeId(employeeId));
            } else {
                message.error(result.payload?.error || "Failed to delete asset request");
            }
        };

        window.addEventListener("ai-delete-asset-request", handler);
        return () =>
            window.removeEventListener("ai-delete-asset-request", handler);
    }, [dispatch, AssetByEmployee]);
    // ---------------------------------------------------
    //            AI Create Promotion
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                Employee,
                promotionTo,
                promotionDate,
                newGrade,
                newDepartment,
                newManager,
                relocate,
                address,
                oldManager,
                oldDepartment,
                promotionfrom,
                experienceLevel
            } = event.detail;

            //VALIDATIONS (same as form)
            if (!Employee) {
                message.error("Employee is required");
                return;
            }
            if (!promotionTo) {
                message.error("Promotion To is required");
                return;
            }
            if (!promotionDate) {
                message.error("Promotion Date is required");
                return;
            }
            if (!newGrade) {
                message.error("New Grade is required");
                return;
            }

            const payload = {
                Employee,
                promotionfrom,
                promotionTo,
                promotionDate,
                newGrade,
                newDepartment,
                newManager,
                relocate: Boolean(relocate),
                address: relocate ? address : null,
                oldManager,
                oldDepartment,
                experienceLevel,
                createdBy: user?.UserId
            };

            const result: any = await dispatch(createPromotion(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success("Promotion created successfully");
                dispatch(fetchAllPromotion());
            } else {
                message.error(result.payload?.error || "Failed to create promotion");
            }
        };

        window.addEventListener("ai-create-promotion", handler);
        return () => window.removeEventListener("ai-create-promotion", handler);
    }, [dispatch, user, promotion]);
    // ---------------------------------------------------
    //            AI Delete Promotion
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Employee name is required");
                return;
            }

            const promotionId = getPromotionIdByEmployeeName(name);

            if (!promotionId) {
                message.error(`Promotion for "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deletepromotion(promotionId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Promotion deleted successfully`);
                dispatch(fetchAllPromotion());
            } else {
                message.error(result.payload?.error || "Failed to delete promotion");
            }
        };

        window.addEventListener("ai-delete-promotion", handler);
        return () => window.removeEventListener("ai-delete-promotion", handler);
    }, [dispatch, promotion]);
    // ---------------------------------------------------
    //                AI Create Branch
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name, pincode, landmark, status, description } = event.detail;

            //Validations
            if (!name) {
                message.error("Branch name is required");
                return;
            }

            if (!pincode || !/^\d{6}$/.test(pincode)) {
                message.error("Valid 6-digit pincode is required");
                return;
            }

            const payload = {
                branchName: name,
                pincode,
                landmark: landmark || "",
                status: status || "active",
                description: description || "",
                createdBy: user?.UserId
            };

            const result: any = await dispatch(createBranch(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Branch "${name}" created successfully`);
                dispatch(fetchAllBranch());
            } else {
                message.error(result.payload?.message || "Failed to create branch");
            }
        };

        window.addEventListener("ai-create-branch", handler);
        return () => window.removeEventListener("ai-create-branch", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    //                AI Delete Branch
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Branch name is required");
                return;
            }

            const match = branch?.find(
                (b: any) =>
                    b.Branch_Name?.toLowerCase() === name.toLowerCase()
            );

            if (!match) {
                message.error(`Branch "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deletebranchById(match.Id));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Branch "${name}" deleted successfully`);
                dispatch(fetchAllBranch());
            } else {
                message.error(result.payload?.message || "Failed to delete branch");
            }
        };

        window.addEventListener("ai-delete-branch", handler);
        return () => window.removeEventListener("ai-delete-branch", handler);
    }, [dispatch, branch]);
    // ---------------------------------------------------
    //            AI Create Termination
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                employeeId,
                terminationType,
                noticeDate,
                terminationDate,
                reason
            } = event.detail;

            //VALIDATIONS (same as form)
            if (!employeeId) {
                message.error("Employee is required");
                return;
            }
            if (!terminationType) {
                message.error("Termination type is required");
                return;
            }
            if (!noticeDate) {
                message.error("Notice date is required");
                return;
            }
            if (!terminationDate) {
                message.error("Termination date is required");
                return;
            }
            if (!reason) {
                message.error("Reason is required");
                return;
            }

            if (dayjs(terminationDate).isAfter(dayjs(noticeDate))) {
                message.error("Termination date cannot be after notice date");
                return;
            }

            const payload = {
                employee: employeeId,
                terminationType,
                noticeDate,
                resignationDate: terminationDate,
                reason,
                createdBy: user?.UserId
            };

            const result: any = await dispatch(createTermination(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success("Termination created successfully");
                dispatch(fetchAllTermination());
            } else {
                message.error(result.payload?.message || "Failed to create termination");
            }
        };

        window.addEventListener("ai-create-termination", handler);
        return () => window.removeEventListener("ai-create-termination", handler);
    }, [dispatch, user, termination]);
    // ---------------------------------------------------
    //            AI Delete Termination
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Employee name is required");
                return;
            }

            const terminationId = getTerminationIdByEmployeeName(name);

            if (!terminationId) {
                message.error(`Termination for "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deletetermination(terminationId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Termination for "${name}" deleted successfully`);
                dispatch(fetchAllTermination());
            } else {
                message.error(result.payload?.message || "Failed to delete termination");
            }
        };

        window.addEventListener("ai-delete-termination", handler);
        return () => window.removeEventListener("ai-delete-termination", handler);
    }, [dispatch, termination]);
    // ---------------------------------------------------
    //            AI Create Resignation
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                employeeId,
                department,
                designation,
                manager,
                hod_id,
                hrId,
                noticeDate,
                resignationDate,
                reason
            } = event.detail;

            // VALIDATIONS (same as form)
            if (!employeeId) {
                message.error("Employee is required");
                return;
            }
            if (!department) {
                message.error("Department is required");
                return;
            }
            if (!designation) {
                message.error("Designation is required");
                return;
            }
            if (!manager) {
                message.error("Manager is required");
                return;
            }
            if (!hod_id) {
                message.error("HOD is required");
                return;
            }
            if (!noticeDate) {
                message.error("Notice date is required");
                return;
            }
            if (!resignationDate) {
                message.error("Resignation date is required");
                return;
            }

            if (dayjs(resignationDate).isAfter(dayjs(noticeDate))) {
                message.error("Resignation date cannot be after notice date");
                return;
            }

            const payload: any = {
                employee: employeeId,
                department,
                designation,
                manager,
                hod_id,
                hrId,
                noticeDate,
                resignationDate,
                reason,
                createdBy: user?.UserId
            };

            const result: any = await dispatch(createResignation(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success("Resignation created successfully");
                dispatch(fetchAllResignations());
            } else {
                message.error(result.payload?.message || "Failed to create resignation");
            }
        };

        window.addEventListener("ai-create-resignation", handler);
        return () => window.removeEventListener("ai-create-resignation", handler);
    }, [dispatch, user, resignation]);
    // ---------------------------------------------------
    //            AI Delete Resignation
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Employee name is required");
                return;
            }

            const resignationId = getResignationIdByEmployeeName(name);

            if (!resignationId) {
                message.error(`Resignation for "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deleteResignation(resignationId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Resignation for "${name}" deleted successfully`);
                dispatch(fetchAllResignations());
            } else {
                message.error(result.payload?.message || "Failed to delete resignation");
            }
        };

        window.addEventListener("ai-delete-resignation", handler);
        return () => window.removeEventListener("ai-delete-resignation", handler);
    }, [dispatch, resignation]);
    // ---------------------------------------------------
    //            AI Create Client
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                first_name,
                last_name,
                email,
                phone_number,
                company,
                company_address,
                industry_type,
                gstin,
                status
            } = event.detail;

            // VALIDATIONS (same as form)
            if (!first_name) { message.error("First name is required"); return; }
            if (!email) { message.error("Email is required"); return; }
            if (!phone_number) { message.error("Phone number is required"); return; }
            if (!company) { message.error("Company is required"); return; }

            const payload = {
                first_name,
                last_name,
                email,
                phone_number,
                company,
                company_address,
                industry_type,
                gstin,
                status: status || "active",
                created_by: user?.UserId,
                client_or_vendor: 0
            };

            const result: any = await dispatch(createClient(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success("Client created successfully");
                dispatch(fetchAllClients());
                dispatch(fetchClientSummary());
            } else {
                message.error(result.payload?.error || "Failed to create client");
            }
        };

        window.addEventListener("ai-create-client", handler);
        return () => window.removeEventListener("ai-create-client", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    //            AI Delete Client
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Client name is required");
                return;
            }

            const match = clients?.find((c: any) =>
                `${c.first_name} ${c.last_name}`.toLowerCase().includes(name.toLowerCase())
            );

            if (!match) {
                message.error(`Client "${name}" not found`);
                return;
            }

            const result: any = await dispatch(
                deleteClient({ clientId: match.client_id })
            );

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Client "${name}" deleted successfully`);
                dispatch(fetchAllClients());
                dispatch(fetchClientSummary());
            } else {
                message.error(result.payload?.error || "Failed to delete client");
            }
        };

        window.addEventListener("ai-delete-client", handler);
        return () => window.removeEventListener("ai-delete-client", handler);
    }, [dispatch, clients]);
    // ---------------------------------------------------
    //            AI Create Task Board
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                Name,
                Description,
                Color,
                Status,
                Project
            } = event.detail || {};

            // SAME VALIDATION AS UI
            if (!Name?.trim()) {
                message.error("Board name is required");
                return;
            }

            if (!Project) {
                message.error("Project is required");
                return;
            }

            // 🧠 DEFAULTS (SAME AS FORM)
            const payload = {
                Name: Name.trim(),
                Description: Description || "",
                Project,
                Color: Color || "#dc3545",
                Status: Status || "active",
                CreatedBy: user?.UserId
            };

            try {
                const result: any = await dispatch(createTaskBoard(payload));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("Task board created successfully");
                    dispatch(fetchTaskBoards());
                } else {
                    message.error(result.payload?.message || "Failed to create task board");
                }
            } catch (err) {
                message.error("Something went wrong while creating task board");
            }
        };

        window.addEventListener("ai-create-task-board", handler);
        return () => window.removeEventListener("ai-create-task-board", handler);
    }, [dispatch, user]);
    // -------------------------------------------
    //          AI Delete Task Board
    // -------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name, taskBoardId } = event.detail || {};

            if (!name && !taskBoardId) { message.error("Task board identifier is required"); return; }

            try {
                let boardIdToDelete: number | undefined = taskBoardId;

                if (!boardIdToDelete && name) {
                    const board = taskBoards.find(
                        (b: any) =>
                            b.Name?.trim().toLowerCase() === name.trim().toLowerCase()
                    );

                    if (!board) {
                        message.error(`Task board "${name}" not found`);
                        return;
                    }

                    boardIdToDelete = board.TaskBoardID;
                }

                if (!boardIdToDelete) {
                    message.error("Unable to determine task board to delete");
                    return;
                }

                const result: any = await dispatch(deleteTaskBoard(Number(boardIdToDelete)));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("Task board deleted successfully");
                    dispatch(fetchTaskBoards());
                } else {
                    message.error(result.payload?.message || "Failed to delete task board");
                }
            } catch (err) {
                message.error("Something went wrong while deleting task board");
            }
        };

        window.addEventListener("ai-delete-task-board", handler);
        return () => window.removeEventListener("ai-delete-task-board", handler);
    }, [dispatch, taskBoards]);
    // ---------------------------------------------------
    //            AI Create Task project
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                Title,
                TotalHours,
                DueDate,
                Project,
                TeamMemberEmployeeId,
                Status,
                Priority,
                Visibility,
                Tags,
                Description,
                file
            } = event.detail || {};

            // SAME VALIDATION AS UI
            if (!Title?.trim()) { message.error("Title is required"); return; }
            if (!TotalHours || isNaN(Number(TotalHours))) { message.error("Total hours is required"); return; }
            if (!DueDate) { message.error("Due date is required"); return; }
            if (!Project) { message.error("Project is required"); return; }
            if (!Array.isArray(TeamMemberEmployeeId) || TeamMemberEmployeeId.length === 0) {
                message.error("At least one team member is required");
                return;
            }
            if (!Status) { message.error("Task board (status) is required"); return; }
            if (!Priority) { message.error("Priority is required"); return; }

            const payload = {
                Title: Title.trim(),
                TotalHours,
                DueDate: dayjs(DueDate).format("YYYY-MM-DD"),
                Project,
                TeamMemberEmployeeId,
                Tags: JSON.stringify(Tags || []),
                Status,
                Priority,
                Visibility: Visibility || "Private",
                Description: Description || "",
                file,
                CreatedBy: user?.UserId
            };

            try {
                const result: any = await dispatch(createTaskProject(payload));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("Task created successfully");
                    dispatch(fetchTasks());
                } else {
                    message.error(result.payload?.message || "Failed to create task");
                }
            } catch (err) {
                message.error("Something went wrong while creating task");
            }
        };

        window.addEventListener("ai-create-task-project", handler);
        return () => window.removeEventListener("ai-create-task-project", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    //            AI Delete Task project
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { taskId, title } = event.detail || {};

            let idToDelete: number | undefined = taskId;

            // If ID not provided → find by title
            if (!idToDelete && title) {
                const task = tasks.find(
                    (t: any) =>
                        t.Title?.trim().toLowerCase() === title.trim().toLowerCase()
                );

                if (!task) {
                    message.error(`Task "${title}" not found`);
                    return;
                }

                idToDelete = task.TaskID;
            }

            if (!idToDelete) {
                message.error("Task identifier is required");
                return;
            }

            try {
                const result: any = await dispatch(deleteTask(idToDelete));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("Task deleted successfully");
                    dispatch(fetchTasks());
                } else {
                    message.error(result.payload?.message || "Failed to delete task");
                }
            } catch (err) {
                message.error("Something went wrong while deleting task");
            }
        };

        window.addEventListener("ai-delete-task-project", handler);
        return () => window.removeEventListener("ai-delete-task-project", handler);
    }, [dispatch, tasks]);
    // ---------------------------------------------------
    //            AI Create Worklog (Timesheet)
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                project_id,
                task_id,
                work_date,
                deadline,
                total_hours,
                remaining_hours,
                hours_logged,
                status,
                description
            } = event.detail || {};

            // SAME VALIDATION AS UI
            if (!project_id) {
                message.error("Project is required");
                return;
            }

            if (!task_id) {
                message.error("Task is required");
                return;
            }

            if (!work_date) {
                message.error("Work date is required");
                return;
            }

            if (!hours_logged || isNaN(Number(hours_logged))) {
                message.error("Hours logged must be a valid number");
                return;
            }

            if (!status) {
                message.error("Status is required");
                return;
            }

            const payload = {
                project_id,
                task_id,
                work_date: dayjs(work_date).format("YYYY-MM-DD"),
                deadline: deadline ? dayjs(deadline).format("YYYY-MM-DD") : null,
                total_hours: Number(total_hours) || 0,
                remaining_hours: Number(remaining_hours) || 0,
                hours_logged: Number(hours_logged),
                status,
                description: description || "",
                created_by: user?.UserId,
                employee_id: employeesbyUser?.employeeId
            };

            try {
                const result: any = await dispatch(createWorkLog(payload));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("Worklog created successfully");
                    dispatch(fetchAllWorkLogs());
                } else {
                    message.error(result.payload?.message || "Failed to create worklog");
                }
            } catch (err) {
                message.error("Something went wrong while creating worklog");
            }
        };

        window.addEventListener("ai-create-worklog", handler);
        return () => window.removeEventListener("ai-create-worklog", handler);
    }, [dispatch, user, employeesbyUser]);
    // ---------------------------------------------------
    //            AI Delete Worklog (Timesheet)
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { work_id, work_date } = event.detail || {};

            let idToDelete = work_id;

            // 🔍 If ID not provided → find by date (fallback)
            if (!idToDelete && work_date) {
                const match = workLogs?.find(
                    (w: any) =>
                        dayjs(w.work_date).format("YYYY-MM-DD") ===
                        dayjs(work_date).format("YYYY-MM-DD")
                );

                if (!match) {
                    message.error(`No worklog found for ${work_date}`);
                    return;
                }

                idToDelete = match.work_id;
            }

            if (!idToDelete) {
                message.error("Worklog identifier is required");
                return;
            }

            try {
                const result: any = await dispatch(deleteWorkLog({ workId: idToDelete }));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("Worklog deleted successfully");
                    dispatch(fetchAllWorkLogs());
                } else {
                    message.error(result.payload?.message || "Failed to delete worklog");
                }
            } catch (err) {
                message.error("Something went wrong while deleting worklog");
            }
        };

        window.addEventListener("ai-delete-worklog", handler);
        return () => window.removeEventListener("ai-delete-worklog", handler);
    }, [dispatch, workLogs]);
    // ---------------------------------------------------
    //            AI create employee mapping
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const payload = {
                ...event.detail,
                createdBy: user?.UserId,
            };

            try {
                const res = await dispatch(createPfEmployee(payload)).unwrap();
                message.success("Employee mapping created successfully");
                dispatch(fetchAllPfEmployees());
            } catch (err: any) {
                message.error(err?.error || "Failed to create PF employee mapping");
            }
        };

        window.addEventListener("ai-create-pf-employee", handler);
        return () => window.removeEventListener("ai-create-pf-employee", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    //          delete employee mapping
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { employeeName } = event.detail || {};

            const match = records.find(
                (r: any) =>
                    r.employeeName?.toLowerCase() === employeeName?.toLowerCase()
            );

            if (!match) {
                message.error(`Employee mapping for "${employeeName}" not found`);
                return;
            }

            try {
                await dispatch(deletePfEmployee(match.pfEmployeeId)).unwrap();
                message.success("Employee mapping deleted successfully");
                dispatch(fetchAllPfEmployees());
            } catch {
                message.error("Failed to delete employee mapping");
            }
        };

        window.addEventListener("ai-delete-pf-employee", handler);
        return () => window.removeEventListener("ai-delete-pf-employee", handler);
    }, [dispatch, records]);
    // ---------------------------------------------------
    // AI Create Provident Fund (AUTO PROCESS)
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                provident_fund_type,
                employee_share_percent,
                organization_share_percent,
                year,
                month,
                earning_head_ids,
            } = event.detail || {};

            // VALIDATIONS
            if (!year || !month) {
                message.error("Year and Month are required");
                return;
            }

            if (!provident_fund_type) {
                message.error("Provident fund type is required");
                return;
            }

            if (
                employee_share_percent === undefined ||
                organization_share_percent === undefined
            ) {
                message.error("Contribution percentages are required");
                return;
            }

            if (!Array.isArray(earning_head_ids) || !earning_head_ids.length) {
                message.error("At least one earning head is required");
                return;
            }

            // ✅ JUST FORWARD EVENT TO PF SCREEN
            window.dispatchEvent(
                new CustomEvent("pf-auto-process", {
                    detail: {
                        provident_fund_type,
                        employee_share_percent,
                        organization_share_percent,
                        year,
                        month,
                        earning_head_ids,
                    },
                })
            );
        };

        window.addEventListener("ai-create-auto-pf-process", handler);
        return () =>
            window.removeEventListener("ai-create-auto-pf-process", handler);
    }, []);
    // ---------------------------------------------------
    //            AI Delete Provident Fund
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { provident_fund_id, employee_name, year, month } = event.detail || {};

            let idToDelete = provident_fund_id;

            // 🔍 Fallback lookup if ID not provided
            if (!idToDelete && employee_name && year && month) {
                const match = records.find(
                    (r: any) =>
                        r.employee_name?.toLowerCase() === employee_name.toLowerCase() &&
                        Number(r.year) === Number(year) &&
                        Number(r.month) === Number(month)
                );

                if (!match) {
                    message.error(
                        `No PF contribution found for ${employee_name} (${month}-${year})`
                    );
                    return;
                }

                idToDelete = match.provident_fund_id;
            }

            if (!idToDelete) {
                message.error("Provident fund identifier is required");
                return;
            }

            try {
                await dispatch(deleteProvidentFund(idToDelete)).unwrap();
                message.success("Provident fund contribution deleted successfully");
                dispatch(fetchAllProvidentFunds());
            } catch (err: any) {
                message.error(
                    err?.error ||
                    err?.message ||
                    "Failed to delete provident fund contribution"
                );
            }
        };

        window.addEventListener("ai-delete-auto-pf-process", handler);
        return () =>
            window.removeEventListener("ai-delete-auto-pf-process", handler);
    }, [dispatch, records]);
    // ---------------------------------------------------
    // AI Create PF Withdrawal
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                pfEmployeeId,
                requestDate,
                amountRequested,
                withdrawalReason,
                attachment,
            } = event.detail || {};

            // ✅ SAME VALIDATION AS UI
            if (!pfEmployeeId) {
                message.error("PF Employee is required");
                return;
            }

            if (!requestDate) {
                message.error("Request Date is required");
                return;
            }

            if (!amountRequested || isNaN(Number(amountRequested)) || Number(amountRequested) <= 0) {
                message.error("Valid amount is required");
                return;
            }

            if (!withdrawalReason) {
                message.error("Withdrawal reason is required");
                return;
            }

            const payload = {
                pfEmployeeId: Number(pfEmployeeId),
                requestDate: dayjs(requestDate).format("YYYY-MM-DD"),
                amountRequested: Number(amountRequested),
                withdrawalReason,
                requeststatus: "Pending",
                status: "active",
                createdBy: user?.UserId,
                attachment, // optional (AI can skip)
            };

            try {
                const result: any = await dispatch(createPfWithdrawal(payload));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("PF Withdrawal Request created successfully");
                    dispatch(fetchAllPfWithdrawals());
                } else {
                    message.error(result.payload?.message || "Failed to create PF withdrawal request");
                }
            } catch {
                message.error("Something went wrong while creating PF withdrawal request");
            }
        };

        window.addEventListener("ai-create-pf-withdrawal", handler);
        return () =>
            window.removeEventListener("ai-create-pf-withdrawal", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    // AI Delete PF Withdrawal
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { pfWithdrawalId } = event.detail || {};

            if (!pfWithdrawalId) {
                message.error("PF Withdrawal ID is required");
                return;
            }

            try {
                const result: any = await dispatch(
                    deletePfWithdrawal(Number(pfWithdrawalId))
                );

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("PF Withdrawal Request deleted successfully");
                    dispatch(fetchAllPfWithdrawals());
                } else {
                    message.error(result.payload?.message || "Failed to delete PF withdrawal request");
                }
            } catch {
                message.error("Something went wrong while deleting PF withdrawal request");
            }
        };

        window.addEventListener("ai-delete-pf-withdrawal", handler);
        return () =>
            window.removeEventListener("ai-delete-pf-withdrawal", handler);
    }, [dispatch]);
    // ---------------------------------------------------
    //            AI Create PF Loan (SELF)
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                requestDate,
                amountRequested,
                loanReason,
                repaymentTenureMonths,
                monthlyInstallment,
                attachment
            } = event.detail;

            // Logged-in user
            const userId = user?.UserId;

            if (!employeesbyUser?.employeeId) {
                message.error("Employee not mapped to user");
                return;
            }

            // Find PF employee for logged-in user
            const pfEmployee = pfEmployees.find(
                (pf: any) => pf.EmployeeID === employeesbyUser.employeeId
            );

            if (!pfEmployee) {
                message.error("PF account not found for logged-in employee");
                return;
            }

            // VALIDATIONS (same as form)
            if (!requestDate) return message.error("Request date is required");
            if (!amountRequested || amountRequested <= 0) return message.error("Valid amount required");
            if (!loanReason) return message.error("Loan reason is required");
            if (!repaymentTenureMonths || repaymentTenureMonths <= 0)
                return message.error("Valid repayment tenure required");

            const payload = {
                pfEmployeeId: pfEmployee.pfEmployeeId,
                requestDate,
                amountRequested,
                loanReason,
                repaymentTenureMonths,
                monthlyInstallment,
                requeststatus: "Pending",
                status: "active",
                createdBy: userId,
                attachment: attachment || null
            };

            const result: any = await dispatch(createPfLoan(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success("PF Loan request created successfully");
                dispatch(fetchAllPfLoans());
            } else {
                message.error(result.payload?.error || "Failed to create PF loan request");
            }
        };

        window.addEventListener("ai-create-pf-loan", handler);
        return () => window.removeEventListener("ai-create-pf-loan", handler);
    }, [dispatch, user, pfEmployees, employeesbyUser]);
    // ---------------------------------------------------
    //            AI Delete PF Loan
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { pfLoanId } = event.detail;

            if (!pfLoanId) {
                message.error("PF Loan ID is required");
                return;
            }

            const result: any = await dispatch(deletePfLoan(pfLoanId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success("PF Loan request deleted successfully");
                dispatch(fetchAllPfLoans());
            } else {
                message.error(result.payload?.error || "Failed to delete PF loan request");
            }
        };

        window.addEventListener("ai-delete-pf-loan", handler);
        return () => window.removeEventListener("ai-delete-pf-loan", handler);
    }, [dispatch]);
    // ---------------------------------------------------
    //                AI Create PF Policy
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                policyName,
                employeeContributionPercent,
                employerContributionPercent,
                maxWageLimit,
                isVoluntary,
                status
            } = event.detail;

            // VALIDATIONS (same as form)
            if (!policyName) {
                message.error("Policy name is required");
                return;
            }

            if (!employeeContributionPercent || employeeContributionPercent <= 0) {
                message.error("Employee contribution must be greater than 0");
                return;
            }

            if (!employerContributionPercent || employerContributionPercent <= 0) {
                message.error("Employer contribution must be greater than 0");
                return;
            }

            const payload = {
                policyName,
                employeeContributionPercent,
                employerContributionPercent,
                maxWageLimit: maxWageLimit || 0,
                isVoluntary: !!isVoluntary,
                status: status || "active",
                createdBy: user?.UserId
            };

            const result: any = await dispatch(createPfPolicy(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`PF Policy "${policyName}" created successfully`);
                dispatch(fetchAllPfPolicies());
            } else {
                message.error(result.payload?.error || "Failed to create PF policy");
            }
        };

        window.addEventListener("ai-create-pf-policy", handler);
        return () => window.removeEventListener("ai-create-pf-policy", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    //                AI Delete PF Policy
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { policyName } = event.detail;

            if (!policyName) {
                message.error("Policy name is required");
                return;
            }

            // Find policy by name (same as designation pattern)
            const match = records?.find((p: any) =>
                p.policyName?.toLowerCase() === policyName.toLowerCase()
            );

            if (!match) {
                message.error(`PF Policy "${policyName}" not found`);
                return;
            }

            const result: any = await dispatch(deletePfPolicy(match.pfPolicyId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`PF Policy "${policyName}" deleted successfully`);
                dispatch(fetchAllPfPolicies());
            } else {
                message.error(result.payload?.error || "Failed to delete PF policy");
            }
        };

        window.addEventListener("ai-delete-pf-policy", handler);
        return () => window.removeEventListener("ai-delete-pf-policy", handler);
    }, [dispatch, records]);
    // ---------------------------------------------------
    //                AI Create TDS Slab
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                tax_name,
                tax_percentage,
                description,
                status,
                effective_date,
                min_amount,
                max_amount,
                age,
                gender
            } = event.detail;

            // VALIDATIONS (same as form)
            if (!tax_name) {
                message.error("Tax regime is required");
                return;
            }

            if (!tax_percentage || tax_percentage < 0 || tax_percentage > 100) {
                message.error("Valid tax percentage is required");
                return;
            }

            if (!effective_date) {
                message.error("Effective date is required");
                return;
            }

            if (!age) {
                message.error("Age range is required");
                return;
            }

            if (!gender) {
                message.error("Gender is required");
                return;
            }

            const payload = {
                tax_name: Number(tax_name),
                tax_percentage: Number(tax_percentage),
                description: description || "",
                status: status || "active",
                createdBy: user?.UserId,
                effective_date,
                min_amount: Number(min_amount) || 0,
                max_amount: Number(max_amount) || 0,
                age,
                gender
            };

            const result: any = await dispatch(createTax(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success("TDS slab created successfully");
                dispatch(fetchAllTaxes());
            } else {
                message.error(result.payload?.error || "Failed to create TDS slab");
            }
        };

        window.addEventListener("ai-create-tax", handler);
        return () => window.removeEventListener("ai-create-tax", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    //                AI Delete TDS Slab
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { description } = event.detail;

            if (!description) {
                message.error("TDS slab description is required");
                return;
            }

            // Find slab by description
            const match = taxes?.find(
                (t: any) =>
                    t.description?.toLowerCase() === description.toLowerCase()
            );

            if (!match) {
                message.error(`TDS slab "${description}" not found`);
                return;
            }

            const result: any = await dispatch(deleteTax(match.tax_id));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`TDS slab "${description}" deleted successfully`);
                dispatch(fetchAllTaxes());
            } else {
                message.error(result.payload?.error || "Failed to delete TDS slab");
            }
        };

        window.addEventListener("ai-delete-tax", handler);
        return () => window.removeEventListener("ai-delete-tax", handler);
    }, [dispatch, taxes]);
    // ---------------------------------------------------
    //                AI Create Tax Regime
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                RegimeName,
                FinancialYearID,
                IsDefault,
                AllowsStandardDeduction,
                StandardDeductionAmount,
                AllowsChapterVI_ADeductions,
                RebateUnderSection87A_MaxIncome,
                RebateUnderSection87A_Amount,
                Status
            } = event.detail;

            if (!RegimeName) {
                message.error("Tax regime name is required");
                return;
            }

            if (!FinancialYearID) {
                message.error("Financial year is required");
                return;
            }

            const payload = {
                RegimeName,
                FinancialYearID,
                IsDefault: !!IsDefault,
                AllowsStandardDeduction: !!AllowsStandardDeduction,
                StandardDeductionAmount: Number(StandardDeductionAmount) || 0,
                AllowsChapterVI_ADeductions: !!AllowsChapterVI_ADeductions,
                RebateUnderSection87A_MaxIncome: Number(RebateUnderSection87A_MaxIncome) || 0,
                RebateUnderSection87A_Amount: Number(RebateUnderSection87A_Amount) || 0,
                Status: Status || "active",
                CreatedBy: user?.UserId,
            };

            const result: any = await dispatch(createTdsTaxRegime(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Tax regime "${RegimeName}" created successfully`);
                dispatch(fetchTdsTaxRegimes());
            } else {
                message.error(result.payload?.error || "Failed to create tax regime");
            }
        };

        window.addEventListener("ai-create-tax-regime", handler);
        return () => window.removeEventListener("ai-create-tax-regime", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    //                AI Delete crTax Regime
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Tax regime name is required");
                return;
            }

            const regimeId = getTaxRegimeIdByName(name);

            if (!regimeId) {
                message.error(`Tax regime "${name}" not found`);
                return;
            }

            const result: any = await dispatch(deleteTdsTaxRegime(regimeId));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Tax regime "${name}" deleted successfully`);
                dispatch(fetchTdsTaxRegimes());
            } else {
                message.error(result.payload?.error || "Failed to delete tax regime");
            }
        };

        window.addEventListener("ai-delete-tax-regime", handler);
        return () => window.removeEventListener("ai-delete-tax-regime", handler);
    }, [dispatch, regimes]);
    // ---------------------------------------------------
    //          AI Create TDS Surcharge & Cess
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                FinancialYearID,
                TaxRegimeID,
                IncomeThresholdForSurcharge1,
                SurchargeRate1_Percentage,
                IncomeThresholdForSurcharge2,
                SurchargeRate2_Percentage,
                HealthAndEducationCessRate_Percentage,
                Status
            } = event.detail;

            if (!FinancialYearID) {
                message.error("Financial Year is required");
                return;
            }

            if (!TaxRegimeID) {
                message.error("Tax Regime is required");
                return;
            }

            if (
                HealthAndEducationCessRate_Percentage === undefined ||
                HealthAndEducationCessRate_Percentage === null
            ) {
                message.error("Health & Education Cess rate is required");
                return;
            }

            const payload = {
                FinancialYearID,
                TaxRegimeID,
                IncomeThresholdForSurcharge1: Number(IncomeThresholdForSurcharge1) || 0,
                SurchargeRate1_Percentage: Number(SurchargeRate1_Percentage) || 0,
                IncomeThresholdForSurcharge2: Number(IncomeThresholdForSurcharge2) || 0,
                SurchargeRate2_Percentage: Number(SurchargeRate2_Percentage) || 0,
                HealthAndEducationCessRate_Percentage: Number(
                    HealthAndEducationCessRate_Percentage
                ),
                Status: Status || "active",
                CreatedBy: user?.UserId
            };

            const result: any = await dispatch(createTdsSurchargeCess(payload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success("Surcharge & Cess created successfully");
                dispatch(fetchTdsSurchargeCessList());
            } else {
                message.error(result.payload?.error || "Failed to create Surcharge & Cess");
            }
        };

        window.addEventListener("ai-create-tds-surcharge-cess", handler);
        return () =>
            window.removeEventListener("ai-create-tds-surcharge-cess", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    //          AI Delete TDS Surcharge & Cess
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                FinancialYearID,
                IncomeThresholdForSurcharge1,
                SurchargeRate1_Percentage
            } = event.detail;

            if (
                !FinancialYearID ||
                IncomeThresholdForSurcharge1 === undefined ||
                SurchargeRate1_Percentage === undefined
            ) {
                message.error("Financial year and surcharge details are required");
                return;
            }

            const record = surchargeCessList.find((item: any) =>
                Number(item.FinancialYearID) === Number(FinancialYearID) &&
                Number(item.IncomeThresholdForSurcharge1) === Number(IncomeThresholdForSurcharge1) &&
                Number(item.SurchargeRate1_Percentage) === Number(SurchargeRate1_Percentage)
            );

            if (!record) {
                message.error("Matching Surcharge & Cess record not found");
                return;
            }

            const result: any = await dispatch(
                deleteTdsSurchargeCess(record.SurchargeCessID)
            );

            if (result.meta.requestStatus === "fulfilled") {
                message.success("Surcharge & Cess deleted successfully");
                dispatch(fetchTdsSurchargeCessList());
            } else {
                message.error(result.payload?.error || "Failed to delete Surcharge & Cess");
            }
        };

        window.addEventListener("ai-delete-tds-surcharge-cess", handler);
        return () =>
            window.removeEventListener("ai-delete-tds-surcharge-cess", handler);
    }, [dispatch, surchargeCessList]);
    // ---------------------------------------------------
    // AI Create / Auto Process TDS (BRIDGE ONLY)
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                FinancialYearID,
                MonthYear,
                TaxRegimeID,
                SurchargeCessID,
                earning_head_ids,
            } = event.detail || {};

            // VALIDATIONS (same idea as PF)
            if (!FinancialYearID || !MonthYear) {
                message.error("Financial Year and Month are required");
                return;
            }

            if (!TaxRegimeID) {
                message.error("Tax Regime is required");
                return;
            }

            if (!SurchargeCessID) {
                message.error("Surcharge & Cess is required");
                return;
            }

            if (!Array.isArray(earning_head_ids) || !earning_head_ids.length) {
                message.error("At least one earning head is required");
                return;
            }

            // ✅ JUST FORWARD EVENT TO TDS SCREEN
            window.dispatchEvent(
                new CustomEvent("tds-auto-process", {
                    detail: {
                        FinancialYearID,
                        MonthYear,              // "YYYY-MM"
                        TaxRegimeID,
                        SurchargeCessID,
                        earning_head_ids,
                    },
                })
            );
        };

        window.addEventListener("ai-auto-process-tds", handler);
        return () =>
            window.removeEventListener("ai-auto-process-tds", handler);
    }, []);
    // ---------------------------------------------------
    //        AI Create ESIC Disablement Type
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name, description } = event.detail;

            if (!name) {
                message.error("Disablement type name is required");
                return;
            }

            const payload = {
                disablement_type: name,
                description: description || "",
            };

            try {
                const result: any = await dispatch(createEsicDisablementType(payload)).unwrap();

                message.success(result?.message || `Disablement type "${name}" created successfully`);
                dispatch(fetchEsicDisablementTypeList());
            } catch (error: any) {
                message.error(error?.error || "Failed to create disablement type");
            }
        };

        window.addEventListener("ai-create-esic-disablement", handler);
        return () => window.removeEventListener("ai-create-esic-disablement", handler);
    }, [dispatch]);
    // ---------------------------------------------------
    //        AI Delete ESIC Disablement Type
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Disablement type name is required");
                return;
            }

            const disablementId = getDisablementIdByName(name);

            if (!disablementId) {
                message.error(`Disablement type "${name}" not found`);
                return;
            }

            try {
                const result: any = await dispatch(deleteEsicDisablementType(disablementId));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success(`Disablement type "${name}" deleted successfully`);
                    dispatch(fetchEsicDisablementTypeList());
                } else {
                    message.error(result.payload?.error || "Failed to delete disablement type");
                }
            } catch {
                message.error("Something went wrong while deleting disablement type");
            }
        };

        window.addEventListener("ai-delete-esic-disablement", handler);
        return () => window.removeEventListener("ai-delete-esic-disablement", handler);
    }, [dispatch, disablementList]);
    // ---------------------------------------------------
    //        AI Create ESIC Branch
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                branch_code,
                branch_name,
                branch_address,
                branch_contact,
            } = event.detail;

            // Basic validation
            if (!branch_code || !branch_name || !branch_address || !branch_contact) {
                message.error("All branch fields are required");
                return;
            }

            const payload = {
                branch_code,
                branch_name,
                branch_address,
                branch_contact,
            };

            try {
                const result: any = await dispatch(createEsicBranch(payload)).unwrap();

                message.success(
                    result?.message || `Branch "${branch_name}" created successfully`
                );

                dispatch(fetchEsicBranchList());
            } catch (error: any) {
                message.error(error?.error || "Failed to create ESIC branch");
            }
        };

        window.addEventListener("ai-create-esic-branch", handler);
        return () => window.removeEventListener("ai-create-esic-branch", handler);
    }, [dispatch]);
    // ---------------------------------------------------
    //        AI Delete ESIC Branch
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Branch name is required");
                return;
            }

            const branchId = getBranchIdByName(name);

            if (!branchId) {
                message.error(`Branch "${name}" not found`);
                return;
            }

            try {
                const result: any = await dispatch(deleteEsicBranch(branchId));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success(`Branch "${name}" deleted successfully`);
                    dispatch(fetchEsicBranchList());
                } else {
                    message.error(result.payload?.error || "Failed to delete branch");
                }
            } catch {
                message.error("Something went wrong while deleting branch");
            }
        };

        window.addEventListener("ai-delete-esic-branch", handler);
        return () => window.removeEventListener("ai-delete-esic-branch", handler);
    }, [dispatch, branchList]);
    // ---------------------------------------------------
    //        AI Create ESIC Reason
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { reason_type, reason_text } = event.detail;

            if (!reason_type || !reason_text) {
                message.error("Reason type and text are required");
                return;
            }

            try {
                const result: any = await dispatch(
                    createEsicReason({ reason_type, reason_text })
                ).unwrap();

                message.success(result?.message || "ESIC reason created successfully");
                dispatch(fetchEsicReasonList());
            } catch (error: any) {
                message.error(error?.error || "Failed to create ESIC reason");
            }
        };

        window.addEventListener("ai-create-esic-reason", handler);
        return () => window.removeEventListener("ai-create-esic-reason", handler);
    }, [dispatch]);
    // ---------------------------------------------------
    //        AI Delete ESIC Reason
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { text } = event.detail;

            if (!text) {
                message.error("Reason text is required");
                return;
            }

            const reasonId = getEsicReasonIdByText(text);

            if (!reasonId) {
                message.error(`ESIC reason "${text}" not found`);
                return;
            }

            try {
                const result: any = await dispatch(deleteEsicReason(reasonId));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success(`ESIC reason "${text}" deleted successfully`);
                    dispatch(fetchEsicReasonList());
                } else {
                    message.error(result.payload?.error || "Failed to delete ESIC reason");
                }
            } catch {
                message.error("Something went wrong while deleting ESIC reason");
            }
        };

        window.addEventListener("ai-delete-esic-reason", handler);
        return () => window.removeEventListener("ai-delete-esic-reason", handler);
    }, [dispatch, reasonList]);
    // ---------------------------------------------------
    //        AI Create ESIC Benefit
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { benefit_name, description } = event.detail;

            if (!benefit_name || !description) {
                message.error("Benefit name and description are required");
                return;
            }

            try {
                const result: any = await dispatch(
                    createEsicBenefitType({ benefit_name, description })
                ).unwrap();

                message.success(
                    result?.message || `ESIC benefit "${benefit_name}" created successfully`
                );

                dispatch(fetchEsicBenefitTypeList());
            } catch (error: any) {
                message.error(error?.error || "Failed to create ESIC benefit");
            }
        };

        window.addEventListener("ai-create-esic-benefit", handler);
        return () => window.removeEventListener("ai-create-esic-benefit", handler);
    }, [dispatch]);
    // ---------------------------------------------------
    //        AI Delete ESIC Benefit
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Benefit name is required");
                return;
            }

            const benefitId = getEsicBenefitIdByName(name);

            if (!benefitId) {
                message.error(`ESIC benefit "${name}" not found`);
                return;
            }

            try {
                const result: any = await dispatch(deleteEsicBenefitType(benefitId));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success(`ESIC benefit "${name}" deleted successfully`);
                    dispatch(fetchEsicBenefitTypeList());
                } else {
                    message.error(result.payload?.error || "Failed to delete ESIC benefit");
                }
            } catch {
                message.error("Something went wrong while deleting ESIC benefit");
            }
        };

        window.addEventListener("ai-delete-esic-benefit", handler);
        return () => window.removeEventListener("ai-delete-esic-benefit", handler);
    }, [dispatch, benefitTypeList]);
    // ---------------------------------------------------
    //      AI Create ESIC Configuration (BRIDGE ONLY)
    // ---------------------------------------------------
    useEffect(() => {
        const handler = (event: any) => {
            const detail = event.detail;

            // basic guard (optional)
            if (!detail) {
                message.error("ESIC configuration data missing");
                return;
            }

            // ✅ JUST FORWARD TO ESIC CONFIG SCREEN
            window.dispatchEvent(
                new CustomEvent("open-esic-configuration-modal", {
                    detail,
                })
            );
        };

        window.addEventListener("ai-create-esic-configuration", handler);
        return () =>
            window.removeEventListener("ai-create-esic-configuration", handler);
    }, []);
    // ---------------------------------------------------
    //        AI Create ESIC Employee Mapping
    // // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                employee_name,
                esic_number,
                esic_branch_name,
                esic_enrollment_date,
                is_esic_applicable,
                remarks
            } = event.detail;

            if (!employee_name || !esic_number || !esic_branch_name || !esic_enrollment_date) {
                message.error("Missing required ESIC employee details");
                return;
            }

            // Find employee
            const employee = allEmployees.find((e: any) =>
                `${e.FirstName} ${e.LastName}`.toLowerCase().includes(employee_name.toLowerCase())
            );

            if (!employee) {
                message.error(`Employee "${employee_name}" not found`);
                return;
            }

            // Find branch
            const branch = branchList.find((b: any) =>
                b.branch_name.toLowerCase() === esic_branch_name.toLowerCase()
            );

            if (!branch) {
                message.error(`ESIC branch "${esic_branch_name}" not found`);
                return;
            }

            const payload = {
                employee_id: employee.EmployeeID,
                esic_number,
                esic_branch_id: branch.branch_id,
                esic_enrollment_date,
                is_esic_applicable,
                remarks
            };

            try {
                const result: any = await dispatch(createEsicEmployee(payload)).unwrap();
                message.success(result?.message || "ESIC employee created successfully");
                dispatch(fetchEsicEmployees());
            } catch (error: any) {
                message.error(error?.error || "Failed to create ESIC employee");
            }
        };

        window.addEventListener("ai-create-esic-employee", handler);
        return () => window.removeEventListener("ai-create-esic-employee", handler);
    }, [dispatch, allEmployees, branchList]);
    // ---------------------------------------------------
    //        AI Delete ESIC Employee Mapping
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { employee_name } = event.detail;

            if (!employee_name) {
                message.error("Employee name is required");
                return;
            }

            const record = esicEmployees.find((emp: any) =>
                emp.Name?.toLowerCase().includes(employee_name.toLowerCase())
            );

            if (!record) {
                message.error(`ESIC mapping for "${employee_name}" not found`);
                return;
            }

            // ✅ TYPE GUARD — REQUIRED
            if (!record.esic_emp_id) {
                message.error("Invalid ESIC employee record");
                return;
            }

            try {
                await dispatch(deleteEsicEmployee(record.esic_emp_id)).unwrap();
                message.success(`ESIC mapping for "${employee_name}" deleted`);
                dispatch(fetchEsicEmployees());
            } catch (error: any) {
                message.error(error?.error || "Failed to delete ESIC mapping");
            }
        };

        window.addEventListener("ai-delete-esic-employee", handler);
        return () =>
            window.removeEventListener("ai-delete-esic-employee", handler);
    }, [dispatch, esicEmployees]);
    // ---------------------------------------------------
    //        AI Create Expense Category
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { category, subCategory, status } = event.detail;

            if (!category || !subCategory) {
                message.error("Category and Sub Category are required");
                return;
            }

            try {
                const payload = {
                    category,
                    subCategory,
                    status: status || "active",
                    createdBy: 1, // or user?.UserId
                };

                const result: any = await dispatch(createCategory(payload)).unwrap();

                message.success(
                    result?.message || `Category "${category}" created successfully`
                );

                dispatch(fetchAllCategories());
            } catch (error: any) {
                message.error(error?.error || "Failed to create category");
            }
        };

        window.addEventListener("ai-create-expense-category", handler);
        return () =>
            window.removeEventListener("ai-create-expense-category", handler);
    }, [dispatch]);
    // ---------------------------------------------------
    //        AI Delete Expense Category
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Category name is required");
                return;
            }

            const categoryId = getCategoryIdByName(name);

            if (!categoryId) {
                message.error(`Category "${name}" not found`);
                return;
            }

            try {
                const result: any = await dispatch(deleteCategory(categoryId));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success(`Category "${name}" deleted successfully`);
                    dispatch(fetchAllCategories());
                } else {
                    message.error(result.payload?.message || "Delete failed");
                }
            } catch {
                message.error("Something went wrong while deleting category");
            }
        };

        window.addEventListener("ai-delete-expense-category", handler);
        return () =>
            window.removeEventListener("ai-delete-expense-category", handler);
    }, [dispatch, categories]);
    // ---------------------------------------------------
    // AI Create Expense
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            if (creatingRef.current) return; // 🚫 block duplicate
            creatingRef.current = true;

            const { expense_name, expense_date, amount, payment_method } = event.detail;

            if (!expense_name || !expense_date || !amount || !payment_method || !employeeId) {
                creatingRef.current = false;
                message.error("All expense fields are required");
                return;
            }

            try {
                await dispatch(
                    createExpense({
                        expense_name,
                        expense_date,
                        amount,
                        payment_method,
                        requestStatus: "Pending",
                        employeeId,
                        createdBy: user?.UserId || 1
                    })
                ).unwrap();

                message.success(`Reimbursement "${expense_name}" created successfully`);
                dispatch(fetchExpensesByEmployeeId(employeeId));
            } catch {
                message.error("Failed to create reimbursement");
            } finally {
                creatingRef.current = false; // ✅ reset
            }
        };

        window.addEventListener("ai-create-accounting-expense", handler);
        return () => window.removeEventListener("ai-create-accounting-expense", handler);
    }, []);
    // ---------------------------------------------------
    // AI Delete Expense
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Reimbursement name is required");
                return;
            }

            const record = expenseByEmployee.find((exp: any) =>
                exp.expense_name?.toLowerCase().includes(name.toLowerCase())
            );

            if (!record?.expense_id) {
                message.error(`Reimbursement "${name}" not found`);
                return;
            }

            try {
                await dispatch(deleteExpense(record.expense_id)).unwrap();
                message.success(`Reimbursement "${name}" deleted successfully`);
                dispatch(fetchExpensesByEmployeeId(employeeId));
            } catch {
                message.error("Failed to delete reimbursement");
            }
        };

        window.addEventListener("ai-delete-accounting-expense", handler);
        return () => window.removeEventListener("ai-delete-accounting-expense", handler);
    }, [dispatch, expenseByEmployee, employeeId]);
    // ---------------------------------------------------
    // AI Create Budget Revenue
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                revenueName,
                categoryId,
                budgetId,
                amount,
                revenueDate,
                status,
                file
            } = event.detail;

            if (
                !revenueName ||
                !categoryId ||
                !budgetId ||
                !amount ||
                !revenueDate
            ) {
                message.error("All budget revenue fields are required");
                return;
            }

            try {
                const form = new FormData();
                form.append("revenueName", revenueName);
                form.append("categoryId", categoryId.toString());
                form.append("budgetId", budgetId.toString());
                form.append("amount", amount.toString());
                form.append("status", status || "active");
                form.append("createdBy", user?.UserId?.toString() || "1");
                form.append("revenueDate", revenueDate);

                if (file) {
                    form.append("file", file);
                }

                const result: any = await dispatch(createBudgetRevenue(form)).unwrap();

                if (result?.status === "success") {
                    message.success(`Budget revenue "${revenueName}" created successfully`);
                    dispatch(fetchAllBudgetRevenues());
                } else {
                    message.error("Failed to create budget revenue");
                }
            } catch (error: any) {
                message.error(error?.error || "Failed to create budget revenue");
            }
        };

        window.addEventListener("ai-create-budget-revenue", handler);
        return () =>
            window.removeEventListener("ai-create-budget-revenue", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    // AI Delete Budget Revenue
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Revenue name is required");
                return;
            }

            const record = revenues.find((rev: any) =>
                rev.revenueName?.toLowerCase().includes(name.toLowerCase())
            );

            if (!record?.budget_revenue_id) {
                message.error(`Budget revenue "${name}" not found`);
                return;
            }

            try {
                const result: any = await dispatch(
                    deleteBudgetRevenue(record.budget_revenue_id)
                );

                if (result.meta.requestStatus === "fulfilled") {
                    message.success(`Budget revenue "${name}" deleted successfully`);
                    dispatch(fetchAllBudgetRevenues());
                } else {
                    message.error(result.payload?.error || "Delete failed");
                }
            } catch {
                message.error("Failed to delete budget revenue");
            }
        };

        window.addEventListener("ai-delete-budget-revenue", handler);
        return () =>
            window.removeEventListener("ai-delete-budget-revenue", handler);
    }, [dispatch, revenues]);
    // ---------------------------------------------------
    // AI Create Budget Expense
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const {
                expenseName,
                categoryId,
                budgetId,
                amount,
                expenseDate,
                status
            } = event.detail;

            if (!expenseName || !categoryId || !budgetId || !amount || !expenseDate) {
                message.error("All budget expense fields are required");
                return;
            }

            try {
                const form = new FormData();
                form.append("expenseName", expenseName);
                form.append("categoryId", categoryId);
                form.append("budgetId", budgetId);
                form.append("amount", amount);
                form.append("expenseDate", expenseDate);
                form.append("status", status || "active");
                form.append("createdBy", user?.UserId?.toString() || "1");

                await dispatch(createBudgetExpense(form)).unwrap();

                message.success(`Budget expense "${expenseName}" created successfully`);
                dispatch(fetchAllBudgetExpenses());
            } catch {
                message.error("Failed to create budget expense");
            }
        };

        window.addEventListener("ai-create-budget-expense", handler);
        return () => window.removeEventListener("ai-create-budget-expense", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    // AI Delete Budget Expense
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            if (!name) {
                message.error("Expense name is required");
                return;
            }

            const record = expenses.find((exp: any) =>
                exp.expenseName?.toLowerCase().includes(name.toLowerCase())
            );

            if (!record?.budget_expense_id) {
                message.error(`Budget expense "${name}" not found`);
                return;
            }

            try {
                await dispatch(deleteBudgetExpense(record.budget_expense_id)).unwrap();
                message.success(`Budget expense "${name}" deleted successfully`);
                dispatch(fetchAllBudgetExpenses());
            } catch {
                message.error("Failed to delete budget expense");
            }
        };

        window.addEventListener("ai-delete-budget-expense", handler);
        return () => window.removeEventListener("ai-delete-budget-expense", handler);
    }, [dispatch, expenses]);
    // ---------------------------------------------------
    // AI Create Budget
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const data = event.detail;

            try {
                const payload = {
                    ...data,
                    startDate: data.startDate,
                    endDate: data.endDate,
                    overallRevenue: parseFloat(data.overallRevenue),
                    overallExpense: parseFloat(data.overallExpense),
                    tax: parseFloat(data.tax),
                    createdBy: user?.id || 1,
                };

                await dispatch(createBudget(payload)).unwrap();
                message.success(`Budget "${data.budgetTitle}" created successfully`);
                dispatch(fetchAllBudgets());
            } catch {
                message.error("Failed to create budget");
            }
        };

        window.addEventListener("ai-create-budget", handler);
        return () => window.removeEventListener("ai-create-budget", handler);
    }, [dispatch, user]);
    // ---------------------------------------------------
    // AI Delete Budget
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            const record = budgets.find((b: any) =>
                b.budgetTitle?.toLowerCase().includes(name.toLowerCase())
            );

            if (!record?.budget_id) {
                message.error(`Budget "${name}" not found`);
                return;
            }

            try {
                await dispatch(deleteBudget(record.budget_id)).unwrap();
                message.success(`Budget "${name}" deleted successfully`);
                dispatch(fetchAllBudgets());
            } catch {
                message.error("Failed to delete budget");
            }
        };

        window.addEventListener("ai-delete-budget", handler);
        return () => window.removeEventListener("ai-delete-budget", handler);
    }, [dispatch, budgets]);
    // ---------------------------------------------------
    // AI Create Work From Home
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { FromDate, ToDate, Days, Description } = event.detail;

            if (!employeeId) {
                message.error("Employee not found");
                return;
            }

            const payload = {
                FromDate,
                ToDate,
                Days,
                Description,
                employeeId,
                CreatedBy: user?.UserId,
            };

            try {
                const res = await dispatch(createWorkfromHome(payload));
                if (res.meta.requestStatus === "fulfilled") {
                    message.success(res.payload.message);
                    dispatch(getworkfromhomeByEmployeeId({ Id: employeeId }));
                } else {
                    message.error(res.payload.message);
                }
            } catch {
                message.error("Failed to create Work From Home request");
            }
        };

        window.addEventListener("ai-create-workfromhome", handler);
        return () =>
            window.removeEventListener("ai-create-workfromhome", handler);
    }, [dispatch, employeeId, user]);
    // ---------------------------------------------------
    // AI Delete Work From Home
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { FromDate } = event.detail;

            const record = workfromhome.find(
                (w: any) =>
                    dayjs(w.FromDate).format("YYYY-MM-DD") ===
                    dayjs(FromDate).format("YYYY-MM-DD")
            );

            if (!record?.Id) {
                message.error("Work From Home request not found");
                return;
            }

            try {
                const res = await dispatch(DeleteWorkfromHome(record.Id));
                if (res.meta.requestStatus === "fulfilled") {
                    message.success(res.payload.message);
                    dispatch(getworkfromhomeByEmployeeId({ Id: employeeId }));
                } else {
                    message.error(res.payload.message);
                }
            } catch {
                message.error("Failed to delete Work From Home request");
            }
        };

        window.addEventListener("ai-delete-workfromhome", handler);
        return () =>
            window.removeEventListener("ai-delete-workfromhome", handler);
    }, [dispatch, workfromhome, employeeId]);
    //-----------------------------------------------------
    // AI Create Vendor
    //-----------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const data = event.detail;

            const payload = {
                ...data,
                created_by: user?.UserId,
                client_or_vendor: 1,
            };

            try {
                const res = await dispatch(createClient(payload));
                if (res.meta.requestStatus === "fulfilled") {
                    message.success("Vendor created successfully");
                    dispatch(fetchAllClients());
                    dispatch(fetchVendorSummary());
                } else {
                    message.error(res.payload?.error || "Failed to create vendor");
                }
            } catch {
                message.error("Failed to create vendor");
            }
        };

        window.addEventListener("ai-create-vendor", handler);
        return () => window.removeEventListener("ai-create-vendor", handler);
    }, [dispatch, user]);
    //delete vendor----------------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            const record = clients.find((v: any) =>
                `${v.first_name} ${v.last_name}`.toLowerCase().includes(name.toLowerCase())
            );

            if (!record?.client_id) {
                message.error(`Vendor "${name}" not found`);
                return;
            }

            try {
                const res = await dispatch(deleteClient({ clientId: record.client_id }));
                if (res.meta.requestStatus === "fulfilled") {
                    message.success("Vendor deleted successfully");
                    dispatch(fetchAllClients());
                    dispatch(fetchVendorSummary());
                } else {
                    message.error(res.payload?.error);
                }
            } catch {
                message.error("Failed to delete vendor");
            }
        };

        window.addEventListener("ai-delete-vendor", handler);
        return () => window.removeEventListener("ai-delete-vendor", handler);
    }, [dispatch, clients]);
    // earning----------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const data = event.detail;

            const payload = {
                ...data,
                Percent: data.Percent || null,
                Amount: data.Amount || null,
                CreatedBy: user?.UserId,
            };

            try {
                const res = await dispatch(createEarning(payload)).unwrap();
                message.success(res.message);
                dispatch(fetchEarnings());
                //   setTableKey((k: number) => k + 1);
            } catch (err: any) {
                message.error(err?.error || "Failed to create earning");
            }
        };

        window.addEventListener("ai-create-earning", handler);
        return () => window.removeEventListener("ai-create-earning", handler);
    }, [dispatch, user]);
    //delete earnings----------------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { name } = event.detail;

            const record = earnings.find((e: any) =>
                e.Name?.toLowerCase().includes(name.toLowerCase())
            );

            if (!record?.Id) {
                message.error(`Earning "${name}" not found`);
                return;
            }

            try {
                const res = await dispatch(deleteEarning(record.Id));
                if (res.meta.requestStatus === "fulfilled") {
                    message.success(res.payload.message);
                    dispatch(fetchEarnings());
                } else {
                    message.error(res.payload.error);
                }
            } catch {
                message.error("Failed to delete earning");
            }
        };

        window.addEventListener("ai-delete-earning", handler);
        return () => window.removeEventListener("ai-delete-earning", handler);
    }, [dispatch, earnings]);
    //------------------------------------------------------------
    //      Ai Create OVertime
    //-------------------------------------------------------------
    useEffect(() => {
        const handleAICreateOvertime = async (e: any) => {
            const data = e.detail;

            try {
                const result = await dispatch(
                    createOvertimePay({
                        ...data,
                        CreatedBy: user?.UserId,
                    })
                ).unwrap();

                message.success(result.message);
                await dispatch(fetchOvertimePays());
                // setTableKey((prev: any) => prev + 1);
                // resetForm();
                // handleCancel();
            } catch (err: any) {
                message.error(err?.error || "Failed to create overtime");
            }
        };

        window.addEventListener("ai-create-overtime", handleAICreateOvertime);

        return () => {
            window.removeEventListener("ai-create-overtime", handleAICreateOvertime);
        };
    }, [dispatch, user?.UserId]);
    //------------------------------------------------------------
    //      Ai Delete OVertime
    //-------------------------------------------------------------
    useEffect(() => {
        const handleAIDeleteOvertime = async (e: any) => {
            const { name } = e.detail;

            const overtime = overtimePays?.find(
                (o: any) => o.Name?.toLowerCase() === name.toLowerCase()
            );

            if (!overtime) {
                message.error(`Overtime "${name}" not found`);
                return;
            }

            try {
                const result = await dispatch(
                    deleteOvertimePay(overtime.ID)
                ).unwrap();

                message.success(result.message);
                await dispatch(fetchOvertimePays());
            } catch (err: any) {
                message.error(err?.error || "Failed to delete overtime");
            }
        };

        window.addEventListener("ai-delete-overtime", handleAIDeleteOvertime);

        return () => {
            window.removeEventListener("ai-delete-overtime", handleAIDeleteOvertime);
        };
    }, [dispatch, overtimePays]);
    //------------------------------------------------------------
    //      Ai Create deduction
    //-------------------------------------------------------------
    useEffect(() => {
        const handleAICreateDeduction = async (e: any) => {
            const data = e.detail;

            try {
                const result = await dispatch(
                    createDeduction({
                        ...data,
                        CreatedBy: user?.UserId,
                    })
                ).unwrap();

                message.success(result.message);
                await dispatch(fetchDeductions());
            } catch (err: any) {
                message.error(err?.error || "Failed to create deduction");
            }
        };

        window.addEventListener("ai-create-deduction", handleAICreateDeduction);

        return () => {
            window.removeEventListener("ai-create-deduction", handleAICreateDeduction);
        };
    }, [dispatch, user?.UserId]);
    //------------------------------------------------------------
    //      Ai Delete deduction
    //-------------------------------------------------------------
    useEffect(() => {
        const handleAIDeleteDeduction = async (e: any) => {
            const { name } = e.detail;

            const deduction = deductions?.find(
                (d: any) =>
                    d.Name?.toLowerCase().trim() === name.toLowerCase().trim()
            );

            if (!deduction) {
                message.error(`Deduction "${name}" not found`);
                return;
            }

            try {
                const result = await dispatch(
                    deleteDeduction(deduction.Id)
                ).unwrap();

                message.success(result.message);
                await dispatch(fetchDeductions());
            } catch (err: any) {
                message.error(err?.error || "Failed to delete deduction");
            }
        };

        window.addEventListener("ai-delete-deduction", handleAIDeleteDeduction);

        return () => {
            window.removeEventListener("ai-delete-deduction", handleAIDeleteDeduction);
        };
    }, [dispatch, deductions]);
    //------------------------------------------------------------
    //      Ai Create pay scale
    //-------------------------------------------------------------
    useEffect(() => {
        const handleAICreatePayscale = async (e: any) => {
            const data = e.detail;

            // 🔑 STEP 1: Resolve RoleName → RoleId
            // const role = roles?.find(
            //     (r: any) =>
            //         r.RoleName.toLowerCase().trim() ===
            //         data.RoleName?.toLowerCase().trim()
            // );

            if (!data.role_id) {
                message.error(`Role "${data.RoleName}" not found`);
                return;
            }

            try {
                const result = await dispatch(
                    createPayscale({
                        RoleId: data.role_id, // ✅ ONLY valid FK
                        SalaryRangeMin: Number(data.SalaryRangeMin),
                        SalaryRangeMax: Number(data.SalaryRangeMax),
                        ExperienceLevel: data.ExperienceLevel,
                        CreatedBy: user?.UserId,
                    })
                ).unwrap();

                message.success(result.message);
                await dispatch(fetchPayscales());
            } catch (err: any) {
                message.error(err?.error || "Failed to create payscale");
            }
        };

        window.addEventListener("ai-create-payscale", handleAICreatePayscale);

        return () => {
            window.removeEventListener("ai-create-payscale", handleAICreatePayscale);
        };
    }, [dispatch, user?.UserId, roles]);

    //------------------------------------------------------------
    //      Ai Delete pay scale
    //-------------------------------------------------------------
    const { payrollScales } = useSelector((state: any) => state.payroll.payrollScall);

    useEffect(() => {
        const handleAIDeletePayscale = async (e: any) => {
            const { roleName } = e.detail;

            const payscale = payrollScales?.find(
                (p: any) =>
                    roles?.find((r: any) =>
                        r.RoleId === p.RoleId &&
                        r.RoleName.toLowerCase() === roleName.toLowerCase()
                    )
            );

            if (!payscale) {
                message.error(`Payscale for "${roleName}" not found`);
                return;
            }

            try {
                const result = await dispatch(
                    deletePayscale(payscale.Id)
                ).unwrap();

                message.success(result.message);
                await dispatch(fetchPayscales());
            } catch (err: any) {
                message.error(err?.error || "Failed to delete payscale");
            }
        };

        window.addEventListener("ai-delete-payscale", handleAIDeletePayscale);

        return () => {
            window.removeEventListener("ai-delete-payscale", handleAIDeletePayscale);
        };
    }, [dispatch, payrollScales, roles]);
    // ---------------------------------------------------
    // AI → PROCESS SALARY (GLOBAL MASTER)
    // ---------------------------------------------------
    useEffect(() => {
        const handler = (event: any) => {
            const { year, month } = event.detail || {};

            if (!year || !month) {
                message.error("Year and Month are required");
                return;
            }

            // ✅ JUST FORWARD EVENT TO EmployeeSalary SCREEN
            window.dispatchEvent(
                new CustomEvent("ai-process-salary", {
                    detail: {
                        year,
                        month
                    }
                })
            );
        };

        window.addEventListener("ai-process-salary-request", handler);

        return () => {
            window.removeEventListener("ai-process-salary-request", handler);
        };
    }, []);
    // ---------------------------------------------------
    // AI → SALARY STRUCTURE (GLOBAL MASTER)
    // ---------------------------------------------------
    useEffect(() => {
        const handler = (event: any) => {
            const payload = event.detail;

            if (!payload?.employee_id || !payload?.pay_scale_id) {
                message.error("Missing required salary structure information");
                return;
            }

            window.dispatchEvent(
                new CustomEvent("ai-create-salary-structure", {
                    detail: payload
                })
            );
        };

        window.addEventListener(
            "ai-create-salary-structure-request",
            handler
        );

        return () => {
            window.removeEventListener(
                "ai-create-salary-structure-request",
                handler
            );
        };
    }, []);
    //------------------------------------------------------------
    //      AI Create Asset Maintenance
    //------------------------------------------------------------
    useEffect(() => {
        const handleAICreateMaintenance = async (e: any) => {
            const data = e.detail;

            try {
                const result = await dispatch(
                    createMaintenance({
                        asset_id: Number(data.asset_id),
                        asset_details_id: Number(data.asset_details_id),
                        maintenance_type: data.maintenance_type,
                        maintenance_date: data.maintenance_date,
                        next_due_date: data.next_due_date,
                        cost: Number(data.cost),
                        vendor: data.vendor,
                        description: data.description || "",
                        status: data.status || "scheduled",
                        EmployeeId: user?.employeeId || user?.EmployeeId,
                        created_by: user?.UserId,
                        modified_by: user?.UserId,
                    })
                ).unwrap();

                message.success(result?.message || "Asset maintenance created successfully");
                await dispatch(fetchAllMaintenances());

            } catch (err: any) {
                message.error(err?.error || "Failed to create asset maintenance");
            }
        };

        window.addEventListener("ai-create-maintenance", handleAICreateMaintenance);

        return () => {
            window.removeEventListener("ai-create-maintenance", handleAICreateMaintenance);
        };
    }, [dispatch, user?.UserId]);
    //------------------------------------------------------------
    //      AI Delete Asset Maintenance
    //------------------------------------------------------------
    useEffect(() => {
        const handleAIDeleteMaintenance = async (e: any) => {
            const { id } = e.detail;

            if (!id || isNaN(Number(id))) {
                message.error("Invalid maintenance ID");
                return;
            }

            try {
                const result = await dispatch(
                    deleteMaintenance(Number(id))
                ).unwrap();

                message.success(result || "Asset maintenance deleted successfully");
                await dispatch(fetchAllMaintenances());

            } catch (err: any) {
                message.error(err?.error || "Failed to delete asset maintenance");
            }
        };

        window.addEventListener("ai-delete-maintenance", handleAIDeleteMaintenance);

        return () => {
            window.removeEventListener("ai-delete-maintenance", handleAIDeleteMaintenance);
        };
    }, [dispatch]);
//------------------------------------------------------------
//      AI CREATE ROLE
//------------------------------------------------------------
useEffect(() => {
    const handleAICreateRole = async (e: any) => {
        const data = e.detail;

        // basic validation (same as UI)
        if (!data?.RoleName) {
            message.error("Role name is required");
            return;
        }
        if (!data?.Status) {
            message.error("Status is required");
            return;
        }

        try {
            const result = await dispatch(
                createRole({
                    RoleName: data.RoleName,
                    Status: data.Status,
                    CreatedBy: user?.UserId,
                    ModifiedBy: user?.UserId,
                })
            ).unwrap();

            message.success(result?.message || "Role created successfully");
            await dispatch(fetchAllRoles());
        } catch (err: any) {
            message.error(err?.error || "Failed to create role");
        }
    };

    window.addEventListener("ai-create-role", handleAICreateRole);

    return () => {
        window.removeEventListener("ai-create-role", handleAICreateRole);
    };
}, [dispatch, user?.UserId]);
//------------------------------------------------------------
//      AI DELETE ROLE
//------------------------------------------------------------
useEffect(() => {
    const handleAIDeleteRole = async (e: any) => {
        const { name } = e.detail;

        if (!name) {
            message.error("Role name is required");
            return;
        }

        const role = roles?.find(
            (r: any) =>
                r.RoleName?.toLowerCase().trim() === name.toLowerCase().trim()
        );

        if (!role) {
            message.error(`Role "${name}" not found`);
            return;
        }

        if (role.Status === "inactive") {
            message.warning(`Role "${name}" is already inactive`);
            return;
        }

        try {
            const result = await dispatch(deleteRole(role.RoleId)).unwrap();

            message.success(result?.message || "Role deleted successfully");
            await dispatch(fetchAllRoles());
        } catch (err: any) {
            message.error(err?.error || "Failed to delete role");
        }
    };

    window.addEventListener("ai-delete-role", handleAIDeleteRole);

    return () => {
        window.removeEventListener("ai-delete-role", handleAIDeleteRole);
    };
}, [dispatch, roles]);
//------------------------------------------------------------
//      AI CREATE EMAIL CONFIGURATION
//------------------------------------------------------------
//------------------------------------------------------------
//      AI CREATE EMAIL CONFIGURATION (WITH LOCAL STATE)
//------------------------------------------------------------
useEffect(() => {
    const handleAICreateEmail = async (e: any) => {
        const data = e.detail;

        // Same validation as UI
        if (!data?.Email) {
            message.error("Email is required");
            return;
        }

        if (!data?.Password) {
            message.error("Password is required");
            return;
        }

        try {
            const result = await dispatch(
                createEmail({
                    Email: data.Email,
                    Password: data.Password,
                    Description: data.Description || "",
                    Status: data.Status || "active",
                })
            ).unwrap();

            message.success(result?.message || "Email configuration created");

            // ✅ UPDATE LOCAL STATE (same as UI)
            const refreshed = await dispatch(fetchAllEmail()).unwrap();
            settabledata(refreshed.data);

        } catch (err: any) {
            message.error(err?.error || "Failed to create email configuration");
        }
    };

    window.addEventListener("ai-create-email", handleAICreateEmail);

    return () => {
        window.removeEventListener("ai-create-email", handleAICreateEmail);
    };
}, [dispatch]);




    /**t
     * Example: Create Designation
     * --------------------------------------
     * window.addEventListener("ai-create-designation", async (event: any) => {
     *      const { name } = event.detail;
     *      await dispatch(createDesignation({ Name: name }));
     * });
     */

    useEffect(() => {
        const handler = async (event: any) => {
            const file = event.detail.file;
            const { field, value } = event.detail;

            // Always include existing values so nothing becomes undefined
            let payload: any = {
                DisplayName: user.DisplayName,
                mobile: user.mobile,
                image: file    // optional
            };

            // Override only the changed field
            if (field === "name") payload.DisplayName = value;
            if (field === "mobile") payload.mobile = value;

            try {
                const result: any = await dispatch(updateUser({
                    userId: user?.UserId,
                    userData: payload
                }));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("Profile updated successfully!");
                    dispatch(getUserById(user?.UserId));
                } else {
                    message.error("Failed to update profile.");
                }
            } catch (error) {
                message.error("Something went wrong!");
            }
        };

        window.addEventListener("ai-update-profile", handler);
        return () => window.removeEventListener("ai-update-profile", handler);
    }, [dispatch, user]);

    // ---------------------------------------------------
    //            AI File Upload (Policy Document)
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const file = event.detail.file;
            const { policyName } = event.detail;

            if (!file) return;

            let payload: any = {
                Name: policyName,
                file
            };

            try {
                const result: any = await dispatch(updatePolicy(payload));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("Policy document updated!");
                    dispatch(fetchAllPolicies());
                } else {
                    message.error("Failed to update policy document");
                }
            } catch (error) {
                message.error("Something went wrong while uploading policy document");
            }
        };

        window.addEventListener("ai-file-upload", handler);
        return () => window.removeEventListener("ai-file-upload", handler);
    }, [dispatch]);

    // ---------------------------------------------------
    //                AI Create Ticket
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const { title, categoryId, departmentId, assignTo, description, priority, status, ticketDate, document } = event.detail;

            if (!title) { message.error("Ticket subject is required"); return; }
            if (!categoryId) { message.error("Ticket category is required"); return; }
            if (!departmentId) { message.error("Department is required"); return; }
            if (!employeesbyUser?.employeeId) { message.error("Employee not found"); return; }

            const formPayload = new FormData();

            formPayload.append("ticket_category_id", categoryId);
            formPayload.append("Request", employeesbyUser.employeeId);
            formPayload.append("TicketDate", ticketDate || new Date().toISOString().split("T")[0]);
            formPayload.append("EmployeeId", assignTo || "");
            formPayload.append("DepartmentId", departmentId);
            formPayload.append("SupervisorId", "");
            formPayload.append("ticket_status", status || "Open");
            formPayload.append("CreatedBy", employeesbyUser.employeeId);

            formPayload.append("ticketDetail[title]", title);
            formPayload.append("ticketDetail[Response]", description || "");
            formPayload.append("ticketDetail[ResponseBy]", employeesbyUser.employeeId);
            formPayload.append("ticketDetail[CreatedBy]", user?.UserId);
            formPayload.append("ticketDetail[AssignedTo]", assignTo || "");
            formPayload.append("ticketDetail[Description]", description || "");
            formPayload.append("ticketDetail[Priority]", priority || "0");
            if (document) { formPayload.append("document", document); }
            const result: any = await dispatch(createTicket(formPayload));

            if (result.meta.requestStatus === "fulfilled") {
                message.success(`Ticket "${title}" created successfully`);

                await dispatch(fetchAllTickets());
                await dispatch(fetchTicketSummary());
                await dispatch(fetchTicketCategorySummary());
                await dispatch(fetchTicketsByDepartment(employeesbyUser.DepartmentId));
                await dispatch(fetchTicketsSummaryByDepartment(employeesbyUser.DepartmentId));
                await dispatch(fetchTicketCategorySummaryByDepartment(employeesbyUser.DepartmentId));

                if (employeesbyUser.employeeId && employeesbyUser.DepartmentId) {
                    dispatch(
                        fetchTicketsByEmployeeHierarchy({
                            employeeId: employeesbyUser.employeeId,
                            departmentId: employeesbyUser.DepartmentId,
                        })
                    );
                }
            } else {
                message.error(result.payload?.error || "Failed to create ticket");
            }
        };

        window.addEventListener("ai-create-ticket", handler);
        return () => window.removeEventListener("ai-create-ticket", handler);
    }, [dispatch, user, employeesbyUser]);


    // ---------------------------------------------------
    //            AI File Upload (Profile Photo)
    // ---------------------------------------------------
    useEffect(() => {
        const handler = async (event: any) => {
            const file = event.detail.file;

            if (!file) return;

            let payload: any = {
                DisplayName: user.DisplayName,
                mobile: user.mobile,
                image: file
            };

            try {
                const result: any = await dispatch(updateUser({
                    userId: user?.UserId,
                    userData: payload
                }));

                if (result.meta.requestStatus === "fulfilled") {
                    message.success("Profile photo updated!");
                    dispatch(getUserById(user?.UserId));
                } else {
                    message.error("Failed to update photo");
                }
            } catch (error) {
                message.error("Something went wrong while uploading photo");
            }
        };

        window.addEventListener("ai-file-upload", handler);
        return () => window.removeEventListener("ai-file-upload", handler);
    }, [dispatch, user]);

    return null;
}
